import { mergeConfigDesktop } from '../../../../theme/app.modules-helper';

const KWICK_MODULES = [
  // LOGIN — enable the member registration link on the shared web login (FLEXO-6063).
  // kwick-only: other admin apps don't override this, so the link stays hidden there.
  {
    name: 'login',
    widgets: {
      default: [
        {
          order: 0,
          className:
            'grid-xs-12 grid-sm-10 grid-md-8 grid-lg-4 m-auto hv-100 flex flex-align-center flex-justify-center',
          id: 'WebLogin',
          type: 'web-login',
          showRegister: true,
          devID: 'daring-dragon',
          devPath: 'login->default->WebLogin',
        },
        {
          order: 1,
          className: '',
          id: 'FloatingLanguageSelector',
          type: 'floating-language-selector',
          devID: 'floating-lang-login',
          devPath: 'login->default->FloatingLanguageSelector',
        },
      ],
    },
  },
  // REGISTER — community member self-registration (FLEXO-6063).
  // Activated for admin-kwick (web) only; reuses the mobile RegisterOOBcode flow
  // (verify billNumber+customerNumber -> create account -> Clerk sign-in).
  // Web layout via className (mobile uses 'p-1'); supervisorWarning is web copy.
  {
    name: 'register',
    active: {
      default: true,
    },
    widgets: {
      default: [
        {
          order: 0,
          className:
            'grid-xs-12 grid-sm-10 grid-md-8 grid-lg-4 m-auto hv-100 flex flex-align-center flex-justify-center',
          id: 'register',
          type: 'register',
          widgetsData: {
            title: 'pages.register.title',
            subtitle: 'pages.register.subtitle',
            supervisorWarning: 'pages.register.supervisor_warning',
            inputs: {
              Stage_1: [
                {
                  name: 'billNumber',
                  label: 'pages.register.bill_number',
                  placeholder: 'pages.register.bill_number_placeholder',
                  action: 'pages.register.bill_number_action',
                  type: 'text',
                },
                {
                  name: 'customerNumber',
                  label: 'pages.register.customer_number',
                  placeholder: 'pages.register.customer_number_placeholder',
                  action: 'pages.register.customer_number_action',
                  type: 'text',
                },
              ],
              Stage_2: [
                {
                  name: 'email',
                  label: 'pages.register.email',
                  placeholder: 'pages.register.email_placeholder',
                  type: 'email',
                },
                {
                  name: 'password',
                  label: 'pages.register.password',
                  placeholder: 'pages.register.password_placeholder',
                  type: 'password',
                },
                {
                  name: 'confirmPassword',
                  label: 'pages.register.confirm_password',
                  placeholder: 'pages.register.confirm_password_placeholder',
                  type: 'password',
                },
              ],
            },
            buttonLabel: 'pages.register.button_label',
            footer: {
              label: 'pages.register.footer.label',
              buttonLabel: 'pages.register.footer.button_label',
            },
            containedLabelTextfield: false,
            textfieldColor: 'grey',
          },
          containedLabelTextfield: false,
          textfieldColor: 'grey',
          devID: 'register-web-kwick',
          devPath: 'register->default->register',
        },
        {
          order: 1,
          className: '',
          id: 'FloatingLanguageSelector',
          type: 'floating-language-selector',
          devID: 'floating-lang-register',
          devPath: 'register->default->FloatingLanguageSelector',
        },
      ],
    },
  },
  // COMMUNITIES
  // {
  //   name: 'communities',
  //   needsAuth: true,
  //   active: {
  //     default: true,
  //   },
  //   visible: {
  //     default: false,
  //   },
  //   sideBar: {
  //     default: false,
  //   },
  //   pullToRefresh: {
  //     default: false,
  //   },
  //   apis: {
  //     default: [
  //       'EntitiesResolver',
  //       'CommunitiesResolver',
  //       'CommunitiesOverviewResolver',
  //       'KwickInvoicesResolver',
  //     ],
  //   },
  //   widgets: {
  //     default: [
  //       {
  //         order: 0,
  //         type: 'headerWeb',
  //         id: 'headerWeb',
  //         className: 'grid-12 mb-6_5',

  //         data: {
  //           label: 'communities',
  //           navigation: false,
  //           calendar: false,
  //           download: false,
  //           searchBar: true,
  //           profile: true,
  //         },
  //         devID: 'rambunctious-dragon',
  //         devPath: 'communities->default->headerWeb',
  //       },
  //       {
  //         className: 'grid-12 p-1 pt-xs-0',
  //         order: 1,
  //         type: 'kwickCommunitiesTable',
  //         id: 'kwickCommunitiesTable',
  //         devID: 'rambunctious-fork',
  //         devPath: 'communities->default->kwickCommunitiesTable',
  //       },
  //     ],
  //   },
  // },
  // COMMUNITY
  {
    name: 'community',
    needsAuth: true,
    needsID: true,
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    sideBar: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    apis: {
      default: [
        'AppConfigResolver',
        'CommunityResolver',
        'MembersResolver',
        'EntitiesResolver',
        'EconomicsKpiCommunityResolver',
        'EnergyKpiCommunityResolver',
        'KwickInvoicesResolver',
      ],
      // FLEXO-6066: end-user-only resolvers for the consolidated /community page
      // (communityStats rings via ComparisonCommunity + CO2 ancillary). Never run
      // for admin/supervisor.
      'org:end_user': [
        'AncillaryKpiCommunityResolver',
        'ComparisonKpiCommunityResolver',
        'EconomicsCustomKpiCommunityResolver',
      ],
    },
    widgets: {
      'org:end_user': {
        consumer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'membersTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            // FLEXO-6089 #1: match producer/consumer_producer margin (mb-6).
            // Old value mb-10_5 created ~168px top gap above the communityStats hero.
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'community',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-compass',
            devPath: 'community->org:end_user->consumer->headerWebEndUser',
          },
          {
            order: 1,
            // FLEXO-6077 #1: hero spans full width (drop px-1 L/R inset).
            className: 'grid-xs-12',
            type: 'communityStats',
            id: 'communityStats',
            gradientBorder: false,
            data: [
              {
                title: 'consumption',
                totalAmount: 'community_import_total',
                color: 'consumption',
                percentage: 'site_import_contribution_rate',
                graphData: [
                  {
                    id: 'consumption',
                    label: 'sites',
                    value: 'site_import_contribution',
                    formattedValue: 'site_import_contribution',
                    color: 'consumption',
                    colorShade: '',
                  },
                  {
                    id: 'consumption',
                    label: 'community',
                    value: 'community_import_total',
                    formattedValue: 'community_import_total',
                    color: 'consumption',
                    colorShade: '20',
                  },
                ],
              },
              {
                title: 'production',
                totalAmount: 'community_export_total',
                color: 'production',
                percentage: 'site_export_contribution_rate',
                graphData: [
                  {
                    id: 'production',
                    label: 'community',
                    value: 'site_export_contribution',
                    formattedValue: 'site_export_contribution',
                    color: 'production',
                    colorShade: '',
                  },
                  {
                    id: 'production',
                    label: 'sites',
                    value: 'community_export_total',
                    formattedValue: 'community_export_total',
                    color: 'production',
                    colorShade: '20',
                  },
                ],
              },
              {
                title: 'shared',
                totalAmount: 'community_shared_total',
                color: 'total_shared',
                percentage: 'site_shared_contribution_rate',
                kpiContext: 'energy',
                graphData: [
                  {
                    id: 'shared',
                    label: 'sites',
                    value: 'site_shared_contribution',
                    formattedValue: 'site_shared_contribution',
                    color: 'total_shared',
                    colorShade: '',
                  },
                  {
                    id: 'shared',
                    label: 'community',
                    value: 'community_shared_total',
                    formattedValue: 'community_shared_total',
                    color: 'total_shared',
                    colorShade: '20',
                  },
                ],
              },
            ],
            devID: 'witty-pebble',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCommunityCardsRow',
            keep: true,
            order: 2,
            className: 'grid-xs-12',
            items: [
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pb-xs-0 pb-lg-1 pr-lg-0_5',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communitySelfSufficiencyCard',
                id: 'communitySelfSufficiencyCard',
                kpiContext: 'energy',
                totalValue: 'self_sufficiency_rate',
                icon: 'self_sufficiency',
                descriptionType: 'label',
                description: 'widgets.communitySelfSufficiencyCard.description.default',
                devID: 'witty-lantern',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-1 pl-lg-0_5 pr-md-0_5',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communityPollutionCard',
                id: 'communityPollutionCard',
                kpiContext: 'ancillary',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.communityPollutionCard.description.default.line_1',
                  line_2: 'widgets.communityPollutionCard.description.default.line_2',
                },
                devID: 'witty-comet',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-1 pl-md-0_5',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communityBenefitsCard',
                id: 'communityBenefitsCard',
                kpiContext: 'economics',
                // FLEXO-6100: the card headline must match the drawer, which
                // shows total_benefits (revenues + savings), not revenues alone.
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionCallback: 'communityTotalEstimatedBenefits',
                descriptionType: 'label',
                description: 'widgets.communityBenefitsCard.description.default',
                descriptionNoData: 'widgets.communityBenefitsCard.description.default_no_data',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.communityTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.communityTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.communityTotalEstimatedBenefits.list_title',
                  listTitleSavingsKey: 'drawers.communityTotalEstimatedBenefits.list_title_savings',
                },
                devID: 'witty-walrus',
              },
            ],
          },
          {
            order: 3,
            className: 'grid-xs-12 p-1 py-xs-0 ',
            type: 'areachart',
            gradientBorder: false,
            subtype: 'areachart',
            id: 'areachart',
            graphKeys: [
              'import_total',
              'export_total',
              'total_shared',
            ],
            colors: [
              'consumption',
              'production',
              'total_shared',
            ],
            title: 'widgets.areaChart.title',
            devID: 'witty-pretzel',
          },
        ],
        producer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'membersTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'community',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-lantern',
            devPath: 'community->org:end_user->producer->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12',
            type: 'communityStats',
            id: 'communityStats',
            gradientBorder: false,
            data: [
              {
                title: 'consumption',
                totalAmount: 'community_import_total',
                color: 'consumption',
                percentage: 'site_import_contribution_rate',
                graphData: [
                  {
                    id: 'consumption',
                    label: 'sites',
                    value: 'site_import_contribution',
                    formattedValue: 'site_import_contribution',
                    color: 'consumption',
                    colorShade: '',
                  },
                  {
                    id: 'consumption',
                    label: 'community',
                    value: 'community_import_total',
                    formattedValue: 'community_import_total',
                    color: 'consumption',
                    colorShade: '20',
                  },
                ],
              },
              {
                title: 'production',
                totalAmount: 'community_export_total',
                color: 'production',
                percentage: 'site_export_contribution_rate',
                graphData: [
                  {
                    id: 'production',
                    label: 'community',
                    value: 'site_export_contribution',
                    formattedValue: 'site_export_contribution',
                    color: 'production',
                    colorShade: '',
                  },
                  {
                    id: 'production',
                    label: 'sites',
                    value: 'community_export_total',
                    formattedValue: 'community_export_total',
                    color: 'production',
                    colorShade: '20',
                  },
                ],
              },
              {
                title: 'shared',
                totalAmount: 'community_shared_total',
                color: 'total_shared',
                percentage: 'site_shared_contribution_rate',
                kpiContext: 'energy',
                graphData: [
                  {
                    id: 'shared',
                    label: 'sites',
                    value: 'site_shared_contribution',
                    formattedValue: 'site_shared_contribution',
                    color: 'total_shared',
                    colorShade: '',
                  },
                  {
                    id: 'shared',
                    label: 'community',
                    value: 'community_shared_total',
                    formattedValue: 'community_shared_total',
                    color: 'total_shared',
                    colorShade: '20',
                  },
                ],
              },
            ],
            devID: 'witty-muffin',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCommunityCardsRow',
            keep: true,
            order: 2,
            className: 'grid-xs-12 px-1',
            items: [
              {
                className: 'grid-xs-12 grid-md-4 p-1',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communitySelfSufficiencyCard',
                id: 'communitySelfSufficiencyCard',
                kpiContext: 'energy',
                totalValue: 'self_sufficiency_rate',
                icon: 'self_sufficiency',
                descriptionType: 'label',
                description: 'widgets.communitySelfSufficiencyCard.description.default',
                devID: 'witty-badger',
              },
              {
                className: 'grid-xs-12 grid-md-4 p-1',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communityPollutionCard',
                id: 'communityPollutionCard',
                kpiContext: 'ancillary',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.communityPollutionCard.description.default.line_1',
                  line_2: 'widgets.communityPollutionCard.description.default.line_2',
                },
                devID: 'witty-anchor',
              },
              {
                className: 'grid-xs-12 grid-md-4 p-1',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communityBenefitsCard',
                id: 'communityBenefitsCard',
                kpiContext: 'economics',
                // FLEXO-6100: the card headline must match the drawer, which
                // shows total_benefits (revenues + savings), not revenues alone.
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionCallback: 'communityTotalEstimatedBenefits',
                descriptionType: 'label',
                description: 'widgets.communityBenefitsCard.description.default',
                descriptionNoData: 'widgets.communityBenefitsCard.description.default_no_data',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.communityTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.communityTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.communityTotalEstimatedBenefits.list_title',
                  listTitleSavingsKey: 'drawers.communityTotalEstimatedBenefits.list_title_savings',
                },
                devID: 'witty-turnip',
              },
            ],
          },
          {
            order: 3,
            className: 'grid-xs-12 px-1 pt-1_5',
            type: 'areachart',
            gradientBorder: false,
            subtype: 'areachart',
            id: 'areachart',
            graphKeys: [
              'import_total',
              'export_total',
              'total_shared',
            ],
            colors: [
              'consumption',
              'production',
              'total_shared',
            ],
            title: 'widgets.areaChart.title',
            devID: 'witty-quokka',
          },
        ],
        consumer_producer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'membersTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'community',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-anchor',
            devPath: 'community->org:end_user->consumer_producer->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12',
            type: 'communityStats',
            id: 'communityStats',
            gradientBorder: false,
            data: [
              {
                title: 'consumption',
                totalAmount: 'community_import_total',
                color: 'consumption',
                percentage: 'site_import_contribution_rate',
                graphData: [
                  {
                    id: 'consumption',
                    label: 'sites',
                    value: 'site_import_contribution',
                    formattedValue: 'site_import_contribution',
                    color: 'consumption',
                    colorShade: '',
                  },
                  {
                    id: 'consumption',
                    label: 'community',
                    value: 'community_import_total',
                    formattedValue: 'community_import_total',
                    color: 'consumption',
                    colorShade: '20',
                  },
                ],
              },
              {
                title: 'production',
                totalAmount: 'community_export_total',
                color: 'production',
                percentage: 'site_export_contribution_rate',
                graphData: [
                  {
                    id: 'production',
                    label: 'community',
                    value: 'site_export_contribution',
                    formattedValue: 'site_export_contribution',
                    color: 'production',
                    colorShade: '',
                  },
                  {
                    id: 'production',
                    label: 'sites',
                    value: 'community_export_total',
                    formattedValue: 'community_export_total',
                    color: 'production',
                    colorShade: '20',
                  },
                ],
              },
              {
                title: 'shared',
                totalAmount: 'community_shared_total',
                color: 'total_shared',
                percentage: 'site_shared_contribution_rate',
                kpiContext: 'energy',
                graphData: [
                  {
                    id: 'shared',
                    label: 'sites',
                    value: 'site_shared_contribution',
                    formattedValue: 'site_shared_contribution',
                    color: 'total_shared',
                    colorShade: '',
                  },
                  {
                    id: 'shared',
                    label: 'community',
                    value: 'community_shared_total',
                    formattedValue: 'community_shared_total',
                    color: 'total_shared',
                    colorShade: '20',
                  },
                ],
              },
            ],
            devID: 'witty-pelican',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCommunityCardsRow',
            keep: true,
            order: 2,
            className: 'grid-xs-12 px-1',
            items: [
              {
                className: 'grid-xs-12 grid-md-4 p-1',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communitySelfSufficiencyCard',
                id: 'communitySelfSufficiencyCard',
                kpiContext: 'energy',
                totalValue: 'self_sufficiency_rate',
                icon: 'self_sufficiency',
                descriptionType: 'label',
                description: 'widgets.communitySelfSufficiencyCard.description.default',
                devID: 'witty-domino',
              },
              {
                className: 'grid-xs-12 grid-md-4 p-1',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communityPollutionCard',
                id: 'communityPollutionCard',
                kpiContext: 'ancillary',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.communityPollutionCard.description.default.line_1',
                  line_2: 'widgets.communityPollutionCard.description.default.line_2',
                },
                devID: 'witty-gecko',
              },
              {
                className: 'grid-xs-12 grid-md-4 p-1',
                type: 'card',
                env: 'web',
                gradientBorder: false,
                subtype: 'communityBenefitsCard',
                id: 'communityBenefitsCard',
                kpiContext: 'economics',
                // FLEXO-6100: the card headline must match the drawer, which
                // shows total_benefits (revenues + savings), not revenues alone.
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionCallback: 'communityTotalEstimatedBenefits',
                descriptionType: 'label',
                description: 'widgets.communityBenefitsCard.description.default',
                descriptionNoData: 'widgets.communityBenefitsCard.description.default_no_data',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.communityTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.communityTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.communityTotalEstimatedBenefits.list_title',
                  listTitleSavingsKey: 'drawers.communityTotalEstimatedBenefits.list_title_savings',
                },
                devID: 'witty-noodle',
              },
            ],
          },
          {
            order: 3,
            className: 'grid-xs-12 px-1 pt-1_5',
            type: 'areachart',
            gradientBorder: false,
            subtype: 'areachart',
            id: 'areachart',
            graphKeys: [
              'import_total',
              'export_total',
              'total_shared',
            ],
            colors: [
              'consumption',
              'production',
              'total_shared',
            ],
            title: 'widgets.areaChart.title',
            devID: 'witty-beacon',
          },
        ],
      },
      default: [
        {
          order: 0,
          className: 'grid-12 mb-6_5 order-xs-1',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'community',
            breadCrumbs: true,
            navigation: true,
            calendar: 'hidden',
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'silly-iceberg',
          devPath: 'community->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 px-1 pb-0_5  order-xs-2',
          id: 'rowsWrapper',
          type: 'rowsWrapper',
          devID: 'waggish-wrapper',
          devPath: 'community->default->rowsWrapper',
          items: [
            {
              order: 1,
              className:
                'grid-xs-12 grid-md-6 grid-lg-4 pl-xs-0 pr-md-0_5 pb-1 pb-lg-0',
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'communityCostsCard',
              id: 'communityCostsCard',
              isOverview: true,
              totalValue: 'total_costs',
              icon: 'bill_no currency_solid',
              kpiContext: 'economics',
              descriptionCallback: 'communityEconomics',
              descriptionType: 'dynamic-label-inline',
              description: 'widgets.communityCostsCard.description.default',
              descriptionNoData:
                'widgets.communityCostsCard.description.default_no_data',
              devID: 'waggish-keyboard',
              devPath: 'community->default->communityCostsCard',
              additionalFields: [
                {
                  field: 'revenues',
                  label: 'widgets.communityCostsCard.revenues_inline',
                },
                {
                  field: 'savings',
                  label: 'widgets.communityCostsCard.savings_inline',
                },
              ],
              drawerConfig: {
                titleKey: 'drawers.communityTotalEstimatedBenefits.title',
                descriptionKey:
                  'drawers.communityTotalEstimatedBenefits.description',
                listTitleKey:
                  'drawers.communityTotalEstimatedBenefits.list_title',
                listTitleSavingsKey:
                  'drawers.communityTotalEstimatedBenefits.list_title_savings',
              },
            },
            {
              order: 2,
              className:
                'grid-xs-12 grid-md-6 grid-lg-4 pr-lg-0_5 pl-md-0_5 pb-1 pb-lg-0',
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'communityEnergyFlowsCard',
              id: 'communityEnergyFlowsCard',
              isOverview: true,
              icon: 'lightning',
              descriptionCallback: 'communityEnergy',
              descriptionType: 'label+value',
              // totalValue: 'import_total',
              description: [
                {
                  key: 'widgets.communityEnergyFlowsCard.description.default.import_total',
                  value: 'import_total',
                },
                {
                  key: 'widgets.communityEnergyFlowsCard.description.default.export_total',
                  value: 'export_total',
                },
                {
                  key: 'widgets.communityEnergyFlowsCard.description.default.total_shared',
                  value: 'total_shared',
                },
              ],
              devID: 'peculiar-koala',
              devPath: 'community->default->communityEnergyFlowsCard',
            },
            {
              order: 3,
              className: 'grid-xs-12 grid-md-12 grid-lg-4 pl-lg-0_5',
              env: 'web',
              type: 'map',
              gradientBorder: false,
              id: 'map',
              devID: 'giddy-cat',
              devPath: 'community->default->map',
            },
          ],
        },

        {
          order: 4,
          className: 'grid-xs-12 grid-xl-9 p-1 pt-xs-0_5 pt-xl-0 pr-xl-0_5 order-xs-4 order-xl-3',
          type: 'membersTable',
          id: 'membersTable',
          devID: 'jazzy-strawberry',
          devPath: 'community->default->membersTable',
        },

        {
          order: 5,
          className:
            'grid-xs-12 grid-xl-3 p-1 py-xs-0_5 pl-xl-0_5 order-xs-3 order-xl-4 flex flex-column flex-sm-row flex-xl-column community-layout__sidebar-pair',
          type: 'parametersDetails',
          id: 'parametersDetails',
          // FLEXO-6064: admin member-detail panel; hidden from end-user sessions.
          roles: ['org:admin', 'org:supervisor', 'administrator', 'supervisor'],
          devID: 'boisterous-kiwi',
          items: [
            {
              className:
                'grid-xs-12 grid-sm-6 pb-xs-1 pr-sm-0_5 pb-sm-0 grid-xl-12 pr-xl-0 pb-xl-1  community-layout__sidebar-pair-item',
              type: 'CommunityDetailsParameters',
              id: 'CommunityDetailsParameters',
              data: {
                title: 'widgets.communityDetailsParameters.title',
                fields: {
                  // communityId:
                  //   'widgets.communityDetailsParameters.communityId',
                  externalId: 'widgets.communityDetailsParameters.externalId',
                  communityCode:
                    'widgets.communityDetailsParameters.communityCode',
                  communityName:
                    'widgets.communityDetailsParameters.communityName',
                  communityType:
                    'widgets.communityDetailsParameters.communityType',
                  startDate: 'widgets.communityDetailsParameters.startDate',
                  communityDates:
                    'widgets.communityDetailsParameters.communityDates',
                  members: 'widgets.communityDetailsParameters.members',
                },
                shownFields: [
                  'communityName',
                  'externalId',
                  'communityType',
                  'members',
                  'communityDates',
                ],
              },
              devID: 'happy-kiwi',
              devPath: 'community->default->CommunityDetailsParameters',
            },
            {
              id: 'communityPaymentsList',
              className:
                'grid-xs-12 grid-sm-6 pl-sm-0_5 grid-xl-12 pl-xl-0 community-layout__sidebar-pair-item',
              devID: 'plucky-kettle',
              devPath: 'community->default->CommunityPaymentsList',
              // hideWhen: 'HIDE_ON_KWICK_NO_INVOICES',
              data: {
                dataItem: 'kwickInvoices',
                title: 'widgets.communityPaymentsList.title',
                paid: 'widgets.communityPaymentsList.paid',
              },
            },
          ],
        },
      ],
    },
  },
  // COMMUNITY ENERGY
  {
    name: 'community-energy',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'CommunityResolver',
        'EnergyCommunityRankingResolver',
        'EnergyKpiCommunityResolver',
        'AncillaryKpiCommunityResolver',
        // 'EnergyCustomKpiCommunityResolver',
      ],
      // FLEXO-6066: end-user-only resolvers for the consolidated layout — the
      // "Benefici stimati" card (economics) and the communityStats rings
      // (ComparisonCommunity). Never run for admin/supervisor.
      'org:end_user': [
        'EconomicsKpiCommunityResolver',
        'ComparisonKpiCommunityResolver',
      ],
    },
    widgets: {
      default: [
        {
          id: 'sharedEnergyCard',
          keep: false,
        },
        {
          id: 'consumptionStackBar',
          keep: false,
        },
        {
          id: 'productionStackBar',
          keep: false,
        },
        {
          id: 'horizontalChartDouble',
          keep: false,
        },
        {
          className: 'grid-12 mb-7_5 mb-md-5_5',
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'community-energy',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: true,
            searchBar: true,
            profile: true,
          },
          devID: 'mirthful-poncho',
          devPath: 'community-energy->default->headerWeb',
        },
        {
          order: 1,
          className:
            'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5 responsiveBackground__xs  responsiveBackground__sm responsiveBackground__md',
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'communityStatsOverviewConsumption',
          totalValue: 'import_total',
          color: 'import_total',
          view: 'community',
          graphDataKeys: [
            {
              key: 'total_shared',
              percentage: 'import_total_total_shared_rate',
              label:
                'widgets.communityStatsOverviewConsumption.import_total_total_shared_rate',
            },
            {
              key: 'from_grid',
              percentage: 'import_total_from_grid_rate',
              label:
                'widgets.communityStatsOverviewConsumption.import_total_from_grid_rate',
            },
          ],
          graphColors: ['from_shared', 'from_grid'],
          title: 'widgets.communityStatsOverviewConsumption.title',
          devID: 'boisterous-plumcake',
          devPath:
            'community-energy->default->communityStatsOverviewConsumption',
        },
        {
          className:
            'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5 responsiveBackground__md',
          order: 2,
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'communityStatsOverviewProduction',
          totalValue: 'export_total',
          color: 'export_total',
          view: 'community',
          graphDataKeys: [
            {
              key: 'total_shared',
              percentage: 'export_total_total_shared_rate',
              label:
                'widgets.communityStatsOverviewProduction.export_to_shared_rate',
            },
            {
              key: 'to_grid',
              percentage: 'export_total_to_grid_rate',
              label:
                'widgets.communityStatsOverviewProduction.export_to_grid_rate',
            },
          ],
          graphColors: ['to_shared', 'to_grid'],
          title: 'widgets.communityStatsOverviewProduction.title',
          devID: 'rowdy-laptop',
          devPath:
            'community-energy->default->communityStatsOverviewProduction',
        },
        {
          order: 4,
          className: 'grid-xs-12 grid-lg-4 pb-xs-0_5 pt-xs-0',
          env: 'web',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          devID: 'unruly-waffle',
          devPath: 'community-energy->default->map',
        },

        {
          id: 'communitySelfSufficiencyCard',
          keep: false,
        },

        {
          order: 5,
          className: 'grid-xs-12 ',
          id: 'rowsWrapper',
          type: 'rowsWrapper',
          devID: 'patient-wrapper',
          devPath: 'community-energy->default->rowsWrapper',
          items: [
            {
              className:
                'grid-xs-12 grid-md-4 grid-lg-4 p-1 py-xs-0_5 pr-md-0_5',
              order: 5,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              detail: false,
              subtype: 'communitySitesCard',
              id: 'communitySitesCard',
              totalValue: 'sites_count',
              icon: 'houses_outline',
              descriptionType: 'membersSitesCard',
              description: [
                {
                  key: 'widgets.totalSitesCard.description.default.consumer',
                  value: 'consumer',
                },
                {
                  key: 'widgets.totalSitesCard.description.default.producer',
                  value: 'producer',
                },
                {
                  key: 'widgets.totalSitesCard.description.default.prosumage',
                  value: 'prosumage',
                },
                {
                  key: 'widgets.totalSitesCard.description.default.prosumer',
                  value: 'prosumer',
                },
              ],
              devID: 'zealous-racoon',
              devPath:
                'community-energy->org:admin->prosumer->communitySitesCard',
            },

            {
              className: 'grid-xs-12 grid-md-4 p-1 py-xs-0_5 px-md-0_5',
              order: 6,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              detail: false,
              subtype: 'communitySelfSufficiencyCard',
              id: 'kwickCommunitySelfSufficiencyCard',
              totalValue: 'self_sufficiency_rate',
              value: 'self_consumption',
              icon: 'self_sufficiency',
              descriptionType: 'label',
              description:
                'widgets.kwickCommunitySelfSufficiencyCard.description.default',
              devID: 'waggish-juice',
              devPath:
                'community-energy->default->kwickCommunitySelfSufficiencyCard',
            },
            {
              className: 'grid-xs-12 grid-md-4 p-1 py-xs-0_5 pl-md-0_5',
              order: 8,
              kpiContext: 'ancillary',
              env: 'web',
              type: 'card',
              gradientBorder: false,
              detail: false,
              subtype: 'communityPollutionCard',
              id: 'communityPollutionCard',
              totalValue: 'co2_offset_kgs',
              trees: 'co2_offset_trees',
              icon: 'pollution',
              descriptionValue: 'co2_offset_trees',
              descriptionType: '{{trees}}',
              description: {
                line_1: 'widgets.pollutionCard.description.prosumer.line_1',
                line_2: 'widgets.pollutionCard.description.prosumer.line_2',
              },
              devID: 'zealous-passionfruit',
              devPath: 'community-energy->default->communityPollutionCard',
            },
          ],
        },

        {
          id: 'consumptionStackBar',
          keep: false,
        },
        {
          order: 9,
          className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'consumptionStackBar',
          id: 'consumptionStackBarKwick',
          totalValue: 'import_total',
          kpiContext: 'energy',
          combinedKeys: null,
          graphKeys: [
            {
              key: 'total_shared',
              color: 'from_shared',
              combined: false,
            },
            {
              key: 'from_grid',
              color: 'from_grid',
              combined: false,
              base: false,
            },
          ],
          title: 'widgets.consumptionStackBar.title',
          devID: 'eccentric-strawberry',
          devPath: 'community-energy->default->consumptionStackBar',
        },
        {
          className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
          order: 10,
          type: 'graphs',
          gradientBorder: false,
          env: 'web',
          subtype: 'productionStackBar',
          id: 'productionStackBarKwick',
          totalValue: 'export_total',
          graphKeys: [
            {
              key: 'total_shared',
              color: 'to_shared',
              combined: false,
            },
            {
              key: 'to_grid',
              color: 'to_grid',
              combined: false,
            },
          ],

          combinedKeys: null,
          title: 'widgets.productionStackBar.title',
          devID: 'banished-jellyfish',
          devPath: 'community-energy->default->productionStackBar',
        },
        {
          className: 'grid-xs-12 grid-lg-12 p-1 py-xs-0_5',
          devID: 'mystical-cat',
          order: 12,
          env: 'web',
          id: 'areaChartSelfConsumption',
          title: 'widgets.areaChart.title',
          type: 'areaChart',
          subtype: 'areaChart',
          gradientBorder: false,
          view: 'community',
          graphKeys: ['import_total', 'export_total', 'total_shared'],
          colors: ['import', 'export', 'total_shared'],
          devPath: 'community-energy->default->areaChartSelfConsumption',
        },

        {
          id: 'horizontalChart',
          keep: false,
        },

        {
          className: 'grid-12 p-1 py-xs-0_5',
          order: 12,
          type: 'horizontalChartDouble',
          gradientBorder: false,
          subtype: 'horizontalChartDouble',
          id: 'horizontalChartDoubleKwick',
          titleCallback: 'HORIZONTAL_CHART',
          context: 'energy',
          rankingKpi: 'import_total',
          kpiNameLabels: ['import_total', 'export_total'],
          rankingKpiName: [
            'widgets.horizontalChart.energy.import_total',
            'widgets.horizontalChart.energy.export_total',
          ],
          graphKeys: [
            ['from_shared', 'from_grid', 'to_shared', 'to_grid'],
            ['from_shared', 'from_grid', 'to_shared', 'to_grid'],
          ],
          combinedKeys: [],
          buttons: [
            'widgets.horizontalChart.energy.from_shared',
            'widgets.horizontalChart.energy.from_grid',
            'widgets.horizontalChart.energy.to_shared',
            'widgets.horizontalChart.energy.to_grid',
          ],
          tooltipColors: [
            [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
          ],
          colors: [
            {
              color: 'from_shared',
              colorShade: '',
            },
            {
              color: 'from_grid',
              colorShade: '',
            },
            {
              color: 'to_shared',
              colorShade: '',
            },
            {
              color: 'to_grid',
              colorShade: '',
            },
          ],
          title: 'widgets.horizontalChart.energy.title',
          devID: 'frisky-flute',
          devPath: 'community-energy->default->horizontalChartDouble',
        },
      ],
      'org:admin': {
        consumer: [
          {
            id: 'sharedEnergyCard',
            keep: false,
          },
          {
            id: 'consumptionStackBar',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'horizontalChart',
            keep: false,
          },
          {
            id: 'horizontalChartDouble',
            keep: false,
          },
          {
            className: 'grid-12 mb-6_5 mb-lg-5_5',
            order: 0,
            type: 'headerWeb',
            id: 'headerWeb',
            data: {
              label: 'community-energy',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: true,
              searchBar: true,
              profile: true,
            },
            devID: 'mirthful-nacho',
            devPath: 'community-energy->default->headerWeb',
          },
          {
            order: 1,
            className:
              'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5 responsiveBackground__xs  responsiveBackground__sm responsiveBackground__md',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'communityStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'community',
            graphDataKeys: [
              {
                key: 'total_shared',
                percentage: 'import_total_total_shared_rate',
                label:
                  'widgets.communityStatsOverviewConsumption.import_total_total_shared_rate',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label:
                  'widgets.communityStatsOverviewConsumption.import_total_from_grid_rate',
              },
            ],
            graphColors: ['from_shared', 'from_grid'],
            title: 'widgets.communityStatsOverviewConsumption.title',
            devID: 'fantasy-yogurt',
            devPath:
              'community-energy->default->communityStatsOverviewConsumption',
          },
          {
            className:
              'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5 responsiveBackground__md',
            order: 2,
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'communityStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'community',
            graphDataKeys: [
              {
                key: 'total_shared',
                percentage: 'export_total_total_shared_rate',
                label:
                  'widgets.communityStatsOverviewProduction.export_to_shared_rate',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label:
                  'widgets.communityStatsOverviewProduction.export_to_grid_rate',
              },
            ],
            graphColors: ['to_shared', 'to_grid'],
            title: 'widgets.communityStatsOverviewProduction.title',
            devID: 'rowdy-lace',
            devPath:
              'community-energy->default->communityStatsOverviewProduction',
          },
          {
            order: 4,
            className: 'grid-xs-12 grid-lg-4 pb-xs-0_5 pt-xs-0',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            devID: 'plucky-marmot',
            devPath: 'community-energy->default->map',
          },

          // {
          //   order: 5,
          //   id: 'rowsWrapper',
          //   type: 'rowsWrapper',
          //   devID: 'ambiguos-wrapper',
          //   devPath: 'community-energy->default->rowsWrapper',
          //   items: [

          //   ]
          // },

          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            combinedKeys: null,
            kpiContext: 'energy',
            graphKeys: [
              {
                key: 'total_shared',
                color: 'from_shared',
                combined: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'eccentric-banana',
            devPath: 'community-energy->default->consumptionStackBar',
          },
          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            order: 10,
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBarKwick',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'total_shared',
                color: 'to_shared',
                combined: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
              },
            ],

            combinedKeys: null,
            title: 'widgets.productionStackBar.title',
            devID: 'banished-otter',
            devPath: 'community-energy->default->productionStackBar',
          },
          {
            className: 'grid-xs-12 grid-lg-12 p-1 py-xs-0_5',
            devID: 'mystical-nacho',
            order: 12,
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChart.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'community',
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devPath: 'community-energy->default->areaChartSelfConsumption',
          },
          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 12,
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            titleCallback: 'HORIZONTAL_CHART',
            id: 'horizontalChartDoubleKwick',
            context: 'energy',
            rankingKpi: 'import',
            kpiNameLabels: ['import_total', 'export_total'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.import_total',
              'widgets.horizontalChart.energy.export_total',
            ],
            graphKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            combinedKeys: [],
            buttons: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
              'widgets.horizontalChart.energy.to_shared',
              'widgets.horizontalChart.energy.to_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'from_shared',
                  colorShade: '',
                },
                {
                  color: 'from_grid',
                  colorShade: '',
                },
                {
                  color: 'to_shared',
                  colorShade: '',
                },
                {
                  color: 'to_grid',
                  colorShade: '',
                },
              ],
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'frisky-foot',
            devPath: 'community-energy->default->horizontalChartDouble',
          },
        ],
        prosumer: [
          {
            id: 'horizontalChart',
            keep: false,
          },
          {
            id: 'communitySelfSufficiencyCard',
            keep: false,
          },
        ],
        consumer_producer: [
          {
            id: 'horizontalChart',
            keep: false,
          },

          {
            id: 'communitySelfSufficiencyCard',
            keep: false,
          },
        ],
        prosumage: [
          {
            id: 'communitySitesCard',
            className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 py-xs-0_5 pr-md-0_5',
            devID: 'bizarre-pasta',
          },
          {
            id: 'communitySelfSufficiencyCard',
            keep: false,
          },
          {
            id: 'kwickCommunitySelfSufficiencyCard',
            className:
              'grid-xs-12 grid-md-6 grid-lg-4 p-1 py-xs-0_5 pr-md-0_5 pl-lg-0_5 pr-lg-0_5',
            devID: 'notorious-fennel',
          },
          {
            id: 'communityPollutionCard',
            className:
              'grid-xs-12 grid-md-6 grid-lg-4 p-1 py-xs-0_5 pr-md-0_5 pl-lg-0_5',
            devID: 'hiding-letter',
          },
          {
            id: 'areaChartSelfConsumption',
            className: 'grid-xs-12 px-1 py-0_5',
            devID: 'fiery-pizza',
          },
        ],

        prosumer_battery: [
          {
            id: 'communitySitesCard',
            className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 py-xs-0_5 pr-md-0_5',
            devID: 'perky-screwdriver',
          },
          {
            id: 'communitySelfSufficiencyCard',
            className:
              'grid-xs-12 grid-md-6 grid-lg-4 p-1 py-xs-0_5 pr-md-0_5 pl-lg-0_5 pr-lg-0_5',
            devID: 'cheerful-avocado',
          },
          {
            id: 'communityPollutionCard',
            className:
              'grid-xs-12 grid-md-6 grid-lg-4 p-1 py-xs-0_5 pr-md-0_5 pr-lg-1 pl-lg-0_5',
            devID: 'glorious-lettuce',
          },
          {
            id: 'areaChartSelfConsumption',
            className: 'grid-xs-12 px-1 py-0_5',
            devID: 'raging-pineapple',
          },
        ],
      },
    },
  },

  // COMMUNITY ECONOMICS
  {
    name: 'community-economics',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'EconomicsKpiCommunityResolver',
        'CommunityResolver',
        'EconomicsCommunityRankingResolver',
        'EconomicsCustomKpiCommunityResolver',
      ],
    },
    widgets: {
      default: [
        {
          className: 'grid-12 mb-10_5 mb-lg-6_5',
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'community-economics',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'eccentric-gumball',
          devPath: 'community-economics->org:admin->default->headerWeb',
        },

        {
          order: 1,
          className: 'grid-xs-12 ',
          id: 'rowsWrapper',
          type: 'rowsWrapper',
          devID: 'ugly-wrapper',
          devPath: 'community-economics->org:admin->default->rowsWrapper',
          items: [
            {
              className: 'grid-12 grid-md-4 p-1 pb-xs-0_5 pt-xs-0 pr-md-0_5',
              order: 1,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'communityCostsCard',
              id: 'communityCostsCard',
              totalValue: 'total_costs',
              icon: 'bill_no currency_solid',
              descriptionType: 'dynamic-label',
              additionalFields: [
                {
                  field: 'community_costs',
                  label: 'widgets.communityCostsCard.community_costs',
                },
                {
                  field: 'other_costs',
                  label: 'widgets.communityCostsCard.other_costs',
                },
              ],
              description: 'widgets.communityCostsCard.description.default',
              descriptionNoData:
                'widgets.communityCostsCard.description.default_no_data',
              descriptionCallback: 'communityTotalCosts',
              kpiContext: 'economics',
              devID: 'wondrous-penguin',
              devPath:
                'community-economics->org:admin->default->communityCostsCard',
              drawerConfig: {
                titleKey: 'drawers.communityCostsCard.title',
                descriptionKey: 'drawers.communityCostsCard.description',
                listTitleKey: 'drawers.communityCostsCard.list_title',
                listTitleCostsKey:
                  'drawers.communityCostsCard.list_title_costs',
              },
            },
            {
              className: 'grid-12 grid-md-4 px-1 py-0_5 pt-md-0 px-md-0_5',
              order: 2,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'communityBenefitsCard',
              id: 'communityBenefitsCard',
              totalValue: 'total_benefits',
              icon: 'savings',
              kpiApiContext: 'economics',
              descriptionType: 'dynamic-label',
              additionalFields: [
                {
                  field: 'revenues',
                  label: 'widgets.communityBenefitsCard.revenues',
                },
                {
                  field: 'savings',
                  label: 'widgets.communityBenefitsCard.savings',
                },
              ],
              description: 'widgets.communityBenefitsCard.description.default',
              descriptionNoData:
                'widgets.communityBenefitsCard.description.default_no_data',
              descriptionCallback: 'communityTotalEstimatedBenefits',
              devID: 'wondrous-armadillo',
              kpiContext: 'economics',
              devPath:
                'community-economics->org:admin->default->communityBenefitsCard',
              drawerConfig: {
                kpiContext: 'economics',
                titleKey: 'drawers.communityTotalEstimatedBenefits.title',
                descriptionKey:
                  'drawers.communityTotalEstimatedBenefits.description',
                listTitleKey:
                  'drawers.communityTotalEstimatedBenefits.list_title',
                listTitleSavingsKey:
                  'drawers.communityTotalEstimatedBenefits.list_title_savings',
              },
            },
            {
              className: 'grid-12 grid-md-4 px-1 py-0_5 pt-md-0 pl-md-0_5',
              order: 3,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'kwickTopSiteCard',
              id: 'kwickTopSiteCard',
              detail: false,
              totalValue: 'total_costs',
              icon: 'house',
              kpiContext: 'economics',
              descriptionType: 'topSiteCard',
              description: 'widgets.kwickTopSiteCard.description.default',
              descriptionNoData:
                'widgets.kwickTopSiteCard.description.default_no_data',
              devPath:
                'community-economics->org:admin->default->kwickTopSiteCard',
            },
          ],
        },

        {
          className: 'grid-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
          order: 4,
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'costsStackBar',
          id: 'costsStackBar',
          totalValue: 'total_costs',
          graphKeys: [
            {
              key: 'community_costs',
              color: 'cost_1',
              combined: false,
            },
            {
              key: 'other_costs',
              color: 'cost_2',
              combined: false,
            },
          ],
          colors: ['cost_1', 'cost_2'],
          title: 'widgets.costsStackBar.title',
          devID: 'angry-pigeon',
          hideWhen: 'HIDE_ON_KWICK_DAYS',
          devPath: 'community-economics->org:admin->default->costsStackBar',
        },

        {
          className: 'grid-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
          order: 5,
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'benefitsStackBar',
          id: 'benefitsStackBar',
          totalValue: 'total_benefits',
          graphKeys: [
            {
              key: 'revenues',
              color: 'revenues',
              combined: false,
            },
            {
              key: 'savings',
              color: 'savings',
              combined: false,
            },
          ],
          colors: ['revenues', 'savings'],
          title: 'widgets.benefitsStackBar.title',
          devID: 'angry-panchin',
          hideWhen: 'HIDE_ON_KWICK_DAYS',
          devPath: 'community-economics->org:admin->default->benefitsStackBar',
        },
        {
          className: 'grid-12 p-1 py-xs-0_5',
          order: 6,
          type: 'horizontalChart',
          gradientBorder: false,
          subtype: 'horizontalChart',
          titleCallback: 'HORIZONTAL_CHART',
          id: 'horizontalChartEconomics',
          entity: 'community',
          context: 'economics',
          rankingKpi: 'total_costs',
          rankingKpiName: 'widgets.horizontalChart.economics.total_costs',
          graphKeys: ['community_costs', 'other_costs'],
          combinedKeys: [],
          buttons: [
            'widgets.horizontalChart.economics.community_costs',
            'widgets.horizontalChart.economics.other_costs',
          ],
          colors: [
            {
              color: 'cost_1',
              colorShade: '',
            },
            {
              color: 'cost_2',
              colorShade: '',
            },
          ],
          title: 'widgets.horizontalChart.economics.title',
          devID: 'ferocious-banana',
          devPath: 'community-economics->org:admin->default->horizontalChart',
        },
      ],
    },
  },

  // MEMBER
  {
    name: 'member',
    needsAuth: true,
    needsID: true,
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    sideBar: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'MembersResolver',
        'MemberResolver',
        'EnergyKpiMemberResolver',
        'EconomicsKpiMemberResolver',
        'KwickInvoicesResolver',
      ],
      // FLEXO-6066: end-user-only resolver for the consolidated /member page —
      // the CO2 (ancillary) pollution card. Never run for admin/supervisor.
      'org:end_user': ['AncillaryKpiMemberResolver', 'EconomicsCustomKpiMemberResolver'],
    },
    widgets: {
      'org:end_user': {
        consumer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'paymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'member',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-beacon',
            devPath: 'member->org:end_user->consumer->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'witty-trombone',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 pb-xs-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'member-energy',
            forceHeight: true,
            devID: 'witty-acorn',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 3,
            className: 'grid-xs-12',
            items: [
              {
                className: 'grid-xs-12 grid-lg-4 p-1 py-xs-0_5 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberCostsCard',
                id: 'memberCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.memberCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.memberCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.memberCostsCard.other_costs',
                  },
                ],
                description: 'widgets.memberCostsCard.description.default',
                descriptionCallback: 'memberTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberCostsCard.title',
                  descriptionKey: 'drawers.memberCostsCard.description',
                  listTitleKey: 'drawers.memberCostsCard.list_title',
                  listTitleCostsKey: 'drawers.memberCostsCard.list_title_costs',
                },
                devID: 'witty-llama',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1  pt-xs-0_5 pb-xs-0_5 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberBenefitsCard',
                id: 'memberBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.memberBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.memberBenefitsCard.savings',
                  },
                ],
                description: 'widgets.memberBenefitsCard.description.default',
                descriptionNoData: 'widgets.memberBenefitsCard.description.default_no_data',
                descriptionCallback: 'memberTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.memberTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
                  listTitleCostsKey: 'drawers.memberTotalEstimatedBenefits.list_title_savings',
                },
                devID: 'witty-cobweb',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0_5 pb-xs-0_5 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'witty-radish',
              },
            ],
          },
          {
            order: 4,
            className: 'grid-xs-12 px-1 pt-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'witty-hamster',
          },
        ],
        producer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'paymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'member',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-needle',
            devPath: 'member->org:end_user->producer->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'witty-jellyfish',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 pt-xs-0 pb-1',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'member-energy',
            forceHeight: true,
            devID: 'witty-kettle',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 3,
            className: 'grid-xs-12',
            items: [
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberCostsCard',
                id: 'memberCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.memberCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.memberCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.memberCostsCard.other_costs',
                  },
                ],
                description: 'widgets.memberCostsCard.description.default',
                descriptionCallback: 'memberTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberCostsCard.title',
                  descriptionKey: 'drawers.memberCostsCard.description',
                  listTitleKey: 'drawers.memberCostsCard.list_title',
                  listTitleCostsKey: 'drawers.memberCostsCard.list_title_costs',
                },
                devID: 'witty-marmot',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberBenefitsCard',
                id: 'memberBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.memberBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.memberBenefitsCard.savings',
                  },
                ],
                description: 'widgets.memberBenefitsCard.description.default',
                descriptionNoData: 'widgets.memberBenefitsCard.description.default_no_data',
                descriptionCallback: 'memberTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.memberTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
                  listTitleCostsKey: 'drawers.memberTotalEstimatedBenefits.list_title_savings',
                },
                devID: 'witty-nugget',
              },
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'witty-pumpkin',
              },
            ],
          },
          {
            order: 4,
            className: 'grid-xs-12 px-1 ',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'witty-raccoon',
          },
        ],
        consumer_producer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'paymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'member',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-ribbon',
            devPath: 'member->org:end_user->consumer_producer->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'witty-tadpole',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 pt-xs-0 pb-1',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'member-energy',
            forceHeight: true,
            devID: 'witty-umbrella',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 3,
            className: 'grid-xs-12',
            items: [
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberCostsCard',
                id: 'memberCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.memberCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.memberCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.memberCostsCard.other_costs',
                  },
                ],
                description: 'widgets.memberCostsCard.description.default',
                descriptionCallback: 'memberTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberCostsCard.title',
                  descriptionKey: 'drawers.memberCostsCard.description',
                  listTitleKey: 'drawers.memberCostsCard.list_title',
                  listTitleCostsKey: 'drawers.memberCostsCard.list_title_costs',
                },
                devID: 'witty-vulture',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberBenefitsCard',
                id: 'memberBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.memberBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.memberBenefitsCard.savings',
                  },
                ],
                description: 'widgets.memberBenefitsCard.description.default',
                descriptionNoData: 'widgets.memberBenefitsCard.description.default_no_data',
                descriptionCallback: 'memberTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.memberTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
                  listTitleCostsKey: 'drawers.memberTotalEstimatedBenefits.list_title_savings',
                },
                devID: 'witty-wombat',
              },
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'witty-yak',
              },
            ],
          },
          {
            order: 4,
            className: 'grid-xs-12 px-1 ',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'witty-zebra',
          },
        ],
        // FLEXO-6105 §2: end-user "All sites" aggregate prosumer layout. Same
        // structure as the single-site end-user prosumer (site module), but the
        // widgets are member-flavoured so the data comes from the member (multi-site
        // aggregate) resolvers. getSiteLayoutHelper now resolves 'prosumer' for the
        // /member aggregate when the member owns at least one prosumer site.
        prosumer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'paymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'member',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'witty-prosumer-header',
            devPath: 'member->org:end_user->prosumer->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6 grid-lg-4',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'witty-prosumer-import',
            devPath: 'member->org:end_user->prosumer->memberStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 grid-lg-4',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'to_shared',
                percentage: 'export_total_to_shared_rate',
                label: 'widgets.siteStatsOverviewProduction.to_shared',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label: 'widgets.siteStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: [
              'to_shared',
              'to_grid',
            ],
            title: 'widgets.siteStatsOverviewProduction.title',
            devID: 'witty-prosumer-export',
            devPath: 'member->org:end_user->prosumer->memberStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'member-energy',
            forceHeight: true,
            devID: 'witty-prosumer-map',
            devPath: 'member->org:end_user->prosumer->map',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 4,
            className: 'grid-xs-12 pt-1',
            items: [
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberCostsCard',
                id: 'memberCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.memberCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.memberCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.memberCostsCard.other_costs',
                  },
                ],
                description: 'widgets.memberCostsCard.description.default',
                descriptionCallback: 'memberTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberCostsCard.title',
                  descriptionKey: 'drawers.memberCostsCard.description',
                  listTitleKey: 'drawers.memberCostsCard.list_title',
                  listTitleCostsKey: 'drawers.memberCostsCard.list_title_costs',
                },
                devID: 'witty-prosumer-costs',
                devPath: 'member->org:end_user->prosumer->memberCostsCard',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberBenefitsCard',
                id: 'memberBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.memberBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.memberBenefitsCard.savings',
                  },
                ],
                description: 'widgets.memberBenefitsCard.description.default',
                descriptionNoData: 'widgets.memberBenefitsCard.description.default_no_data',
                descriptionCallback: 'memberTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.memberTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
                  listTitleCostsKey: 'drawers.memberTotalEstimatedBenefits.list_title_savings',
                },
                devID: 'witty-prosumer-benefits',
                devPath: 'member->org:end_user->prosumer->memberBenefitsCard',
              },
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'witty-prosumer-pollution',
                devPath: 'member->org:end_user->prosumer->pollutionCard',
              },
            ],
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-6 px-1 pb-1 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'witty-prosumer-import-bar',
            devPath: 'member->org:end_user->prosumer->consumptionStackBar',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-6 px-1 pb-1 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'witty-prosumer-export-bar',
            devPath: 'member->org:end_user->prosumer->productionStackBar',
          },
          {
            order: 7,
            className: 'grid-xs-12 px-1 pb-1',
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devID: 'witty-prosumer-area',
            devPath: 'member->org:end_user->prosumer->areaChartSelfConsumption',
          },
        ],
        // FLEXO-6105 §2: no dedicated end-user battery visualisation exists yet, so a
        // member that owns a prosumage (battery) site reuses the prosumer layout —
        // this keeps production visible instead of falling back to the consumer
        // layout. Swap in battery widgets here once a design is available.
        prosumer_battery: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'paymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'member',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'witty-battery-header',
            devPath: 'member->org:end_user->prosumer_battery->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6 grid-lg-4',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'witty-battery-import',
            devPath: 'member->org:end_user->prosumer_battery->memberStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 grid-lg-4',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'to_shared',
                percentage: 'export_total_to_shared_rate',
                label: 'widgets.siteStatsOverviewProduction.to_shared',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label: 'widgets.siteStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: [
              'to_shared',
              'to_grid',
            ],
            title: 'widgets.siteStatsOverviewProduction.title',
            devID: 'witty-battery-export',
            devPath: 'member->org:end_user->prosumer_battery->memberStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'member-energy',
            forceHeight: true,
            devID: 'witty-battery-map',
            devPath: 'member->org:end_user->prosumer_battery->map',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 4,
            className: 'grid-xs-12 pt-1',
            items: [
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberCostsCard',
                id: 'memberCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.memberCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.memberCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.memberCostsCard.other_costs',
                  },
                ],
                description: 'widgets.memberCostsCard.description.default',
                descriptionCallback: 'memberTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberCostsCard.title',
                  descriptionKey: 'drawers.memberCostsCard.description',
                  listTitleKey: 'drawers.memberCostsCard.list_title',
                  listTitleCostsKey: 'drawers.memberCostsCard.list_title_costs',
                },
                devID: 'witty-battery-costs',
                devPath: 'member->org:end_user->prosumer_battery->memberCostsCard',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'memberBenefitsCard',
                id: 'memberBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.memberBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.memberBenefitsCard.savings',
                  },
                ],
                description: 'widgets.memberBenefitsCard.description.default',
                descriptionNoData: 'widgets.memberBenefitsCard.description.default_no_data',
                descriptionCallback: 'memberTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.memberTotalEstimatedBenefits.title',
                  descriptionKey: 'drawers.memberTotalEstimatedBenefits.description',
                  listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
                  listTitleCostsKey: 'drawers.memberTotalEstimatedBenefits.list_title_savings',
                },
                devID: 'witty-battery-benefits',
                devPath: 'member->org:end_user->prosumer_battery->memberBenefitsCard',
              },
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'witty-battery-pollution',
                devPath: 'member->org:end_user->prosumer_battery->pollutionCard',
              },
            ],
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-6 px-1 pb-1 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'witty-battery-import-bar',
            devPath: 'member->org:end_user->prosumer_battery->consumptionStackBar',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-6 px-1 pb-1 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'witty-battery-export-bar',
            devPath: 'member->org:end_user->prosumer_battery->productionStackBar',
          },
          {
            order: 7,
            className: 'grid-xs-12 px-1 pb-1',
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devID: 'witty-battery-area',
            devPath: 'member->org:end_user->prosumer_battery->areaChartSelfConsumption',
          },
        ],
      },
      default: [
        {
          order: 0,
          className: 'grid-12 mb-6_5',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'member',
            breadCrumbs: true,
            navigation: true,
            calendar: 'hidden',
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'zany-penguin',
          devPath: 'member->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 ',
          id: 'rowsWrapper',
          type: 'rowsWrapper',
          devID: 'ancient-wrapper',
          devPath: 'member->default->rowsWrapper',
          items: [
            {
              order: 1,
              className:
                'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pb-xs-0_5 pr-md-0_5',
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'memberCostsCard',
              id: 'memberCostsCard',
              totalValue: 'total_costs',
              isOverview: true,
              icon: 'bill_no currency_solid',
              kpiContext: 'economics',
              descriptionCallback: 'MemberBenefits',
              descriptionType: 'dynamic-label-inline',
              description: 'widgets.memberCostsCard.description.default',
              descriptionNoData:
                'widgets.memberCostsCard.description.default_no_data',
              devID: 'jazzy-trouser',
              devPath: 'member->default->memberCostsCard',
              additionalFields: [
                {
                  field: 'revenues',
                  label: 'widgets.memberCostsCard.revenues_inline',
                },
                {
                  field: 'savings',
                  label: 'widgets.memberCostsCard.savings_inline',
                },
              ],
              drawerConfig: {
                titleKey: 'drawers.memberTotalEstimatedBenefits.title',
                descriptionKey:
                  'drawers.memberTotalEstimatedBenefits.description',
                listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
                listTitleSavingsKey:
                  'drawers.memberTotalEstimatedBenefits.list_title_savings',
              },
            },
            {
              order: 2,
              className:
                'grid-xs-12 grid-md-6 grid-lg-4 px-1 pt-xs-0 pb-xs-0_5 pl-md-0_5 px-lg-0_5',
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'memberEnergyFlowsCard',
              id: 'memberEnergyFlowsCard',
              icon: 'lightning',
              descriptionCallback: 'memberEnergy',
              descriptionType: '[member]label+value',
              isOverview: true,
              // totalValue: 'import_total',
              description: [
                {
                  key: 'widgets.memberEnergyFlowsCard.description.default.import_total',
                  value: 'import_total',
                },
                {
                  key: 'widgets.memberEnergyFlowsCard.description.default.export_total',
                  value: 'export_total',
                },
                {
                  key: 'widgets.memberEnergyFlowsCard.description.default.total_shared',
                  value: 'total_shared',
                },
              ],
              devID: 'rambunctious-shoe',
              devPath: 'member->default->memberEnergyFlowsCard',
            },
            {
              order: 3,
              className:
                'grid-xs-12 grid-lg-4 px-1 pt-lg-0 py-xs-0_5 pl-lg-0_5',
              env: 'web',
              type: 'map',
              gradientBorder: false,
              id: 'map',
              context: 'member',
              devID: 'crazy-cat',
              devPath: 'member->default->map',
            },
          ],
        },

        {
          order: 4,
          className: 'grid-xs-12 grid-xl-9 p-1 pt-xs-0_5 pt-xl-0 pr-xl-0_5 order-xs-4 order-xl-3',
          type: 'paymentsTable',
          id: 'paymentsTable',
          // FLEXO-6064: admin-only; end users get the invoices drawer (FLEXO-6067).
          roles: ['org:admin', 'org:supervisor', 'administrator', 'supervisor'],
          devID: 'waggish-cow',
          devPath: 'member->default->paymentsTable',
          showTable: true,
        },
        {
          order: 5,
          className:
            'grid-xs-12 grid-xl-3 p-1 py-xs-0_5 pl-xl-0_5 order-xs-3 order-xl-4 flex flex-column flex-sm-row flex-xl-column community-layout__sidebar-pair',
          type: 'parametersDetails',
          id: 'parametersDetails',
          // FLEXO-6064: admin member-detail panel; hidden from end-user sessions.
          roles: ['org:admin', 'org:supervisor', 'administrator', 'supervisor'],
          devID: 'boisterous-flower',
          items: [
            {
              className:
                'grid-xs-12 grid-sm-6 pb-xs-1 pr-sm-0_5 pb-sm-0 grid-xl-12 pr-xl-0 pb-xl-1 community-layout__sidebar-pair-item',
              type: 'MemberDetailsParameters',
              id: 'MemberDetailsParameters',
              data: {
                title: 'widgets.memberDetailsParameters.title',
                fields: {
                  communityId: 'widgets.memberDetailsParameters.communityId',
                  externalId: 'widgets.memberDetailsParameters.externalId',
                  // communityCode: 'widgets.memberDetailsParameters.communityCode',
                  communityName:
                    'widgets.memberDetailsParameters.communityName',
                  communityType:
                    'widgets.memberDetailsParameters.communityType',
                  startDate: 'widgets.memberDetailsParameters.startDate',
                  memberId: 'widgets.memberDetailsParameters.memberId',
                  clientId: 'widgets.memberDetailsParameters.clientId',
                  name: 'widgets.memberDetailsParameters.name',
                  address: 'widgets.memberDetailsParameters.address',
                  city: 'widgets.memberDetailsParameters.city',
                  postcode: 'widgets.memberDetailsParameters.postcode',
                  phone: 'widgets.memberDetailsParameters.phone',
                  email: 'widgets.memberDetailsParameters.email',
                  sitesNumber: 'widgets.memberDetailsParameters.sitesNumber',
                  lastAppActivity:
                    'widgets.memberDetailsParameters.lastAppActivity',
                  disabledAt: 'widgets.memberDetailsParameters.disabledAt',
                  appAccount: 'widgets.memberDetailsParameters.appAccount',
                },
                shownFields: [
                  'memberId',
                  'address',
                  'city',
                  'phone',
                  'email',
                  'sitesNumber',
                  'lastAppActivity',
                  'disabledAt',
                  'appAccount',
                ],
              },
              devID: 'glowing-emmenthaler',
              devPath: 'member->default->MemberDetailsParameters',
            },
            {
              className:
                'grid-xs-12 grid-sm-6 pl-sm-0_5 grid-xl-12 pl-xl-0 community-layout__sidebar-pair-item',
              type: 'memberSitesList',
              id: 'memberSitesList',
              devID: 'golden-chair',
              devPath: 'member->default->memberSitesList',
            },
          ],
        },
      ],
    },
  },
  // MEMBER ENERGY
  {
    name: 'member-energy',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'MemberResolver',
        'EnergyKpiMemberResolver',
        'AncillaryKpiMemberResolver',
        'EnergyMemberRankingResolver',
        'EnergyCustomKpiMemberResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          className: 'grid-12 mb-9_5 mb-lg-5',
          data: {
            label: 'member-energy',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: true,
            searchBar: true,
            profile: true,
          },
          devID: 'mystical-balloon',
          devPath: 'member-energy->default->headerWeb',
        },
        {
          order: 1,
          className:
            'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5 responsiveBackground__xs  responsiveBackground__sm responsiveBackground__md',
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'memberStatsOverviewConsumption',
          totalValue: 'import_total',
          color: 'import_total',
          view: 'member',
          graphDataKeys: [
            {
              key: 'from_shared',
              percentage: 'import_total_from_shared_rate',
              label: 'widgets.memberStatsOverviewConsumption.from_shared',
            },
            {
              key: 'from_grid',
              percentage: 'import_total_from_grid_rate',
              label: 'widgets.memberStatsOverviewConsumption.from_grid',
            },
          ],
          graphColors: ['from_shared', 'from_grid'],
          title: 'widgets.memberStatsOverviewConsumption.title',
          devID: 'zesty-marshmallow',
          devPath: 'member-energy->default->memberStatsOverviewConsumption',
        },
        {
          order: 2,
          className:
            'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5 responsiveBackground__md',
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'memberStatsOverviewProduction',
          totalValue: 'export_total',
          color: 'export_total',
          view: 'member',
          graphDataKeys: [
            {
              key: 'to_shared',
              percentage: 'export_total_to_shared_rate',
              label: 'widgets.memberStatsOverviewProduction.to_shared',
            },
            {
              key: 'to_grid',
              percentage: 'export_total_to_grid_rate',
              label: 'widgets.memberStatsOverviewProduction.to_grid',
            },
          ],
          graphColors: ['to_shared', 'to_grid'],
          title: 'widgets.memberStatsOverviewProduction.title',
          devID: 'witty-rollercoaster',
          devPath: 'member-energy->default->memberStatsOverviewProduction',
        },
        {
          order: 3,
          className: 'grid-xs-12 grid-lg-4 pb-0_5',
          env: 'web',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          devID: 'wild-pencil',
          devPath: 'member-energy->default->map',
        },

        {
          id: 'memberSelfSufficiencyCard',
          keep: false,
        },
        {
          order: 5,
          className: 'grid-xs-12 grid-md-6 px-1 pt-xs-0 pb-0_5 px-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,
          subtype: 'memberSharedEnergyCard',
          id: 'memberSharedEnergyCard',
          totalValue: 'total_shared',
          icon: 'shared_energy',
          descriptionType: 'label',
          description: 'widgets.sharedEnergyCard.description.default',
          devID: 'rampaging-jellyfish',
          devPath: 'member-energy->default->memberSharedEnergyCard',
        },
        {
          order: 6,
          className: 'grid-xs-12 grid-lg-6 px-1 pt-xs-0 pb-0_5 px-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          kpiContext: 'ancillary',
          detail: false,
          subtype: 'memberPollutionCard',
          id: 'memberPollutionCard',
          totalValue: 'co2_offset_kgs',
          trees: 'co2_offset_trees',
          icon: 'pollution',
          descriptionValue: 'co2_offset_trees',
          descriptionType: '{{trees}}',
          description: {
            line_1: 'widgets.memberPollutionCard.description.prosumer.line_1',
            line_2: 'widgets.memberPollutionCard.description.prosumer.line_2',
          },
          devID: 'boisterous-spoon',
          devPath: 'member-energy->default->memberPollutionCard',
        },
        {
          order: 7,
          className: 'grid-xs-12 grid-lg-6 px-1 pt-xs-0_5 pb-xs-0_5',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'consumptionStackBar',
          id: 'consumptionStackBar',
          totalValue: 'import_total',
          kpiContext: 'Energy',
          graphKeys: [
            {
              key: 'from_shared',
              color: 'from_shared',
              combined: false,
              base: false,
            },
            {
              key: 'from_grid',
              color: 'from_grid',
              combined: false,
              base: false,
            },
          ],

          colors: [
            {
              color: 'from_shared',
              colorShade: '',
            },
            {
              color: 'from_grid',
              colorShade: '60',
            },
          ],
          title: 'widgets.consumptionStackBar.title',
          devID: 'whacky-dog',
          devPath: 'member-energy->default->consumptionStackBar',
          keep: false,
        },
        {
          order: 8,
          className: 'grid-xs-12 grid-lg-6 mt-0_5 py-0_5 pl-0_5 pr-1',
          type: 'graphs',
          gradientBorder: false,
          env: 'web',
          subtype: 'productionStackBar',
          id: 'productionStackBar',
          totalValue: 'export_total',
          graphKeys: [
            {
              key: 'to_shared',
              color: 'to_shared',
              combined: false,
              base: false,
            },
            {
              key: 'to_grid',
              color: 'to_grid',
              combined: false,
              base: false,
            },
          ],

          colors: [
            {
              color: 'to_shared',
              colorShade: '',
            },
            {
              color: 'to_grid',
              colorShade: '',
            },
          ],
          title: 'widgets.productionStackBar.title',
          devID: 'zippy-lollipop',
          devPath: 'member-energy->default->productionStackBar',
        },
        {
          order: 9,
          className: 'grid-xs-12 grid-lg-6 mt-0_5 py-0_5 pl-1 pr-0_5',
          id: 'batteryChart',
          title: 'widgets.batteryChart.title',
          type: 'batteryChart',
          gradientBorder: false,
          context: 'member',
          buttons: ['widgets.batteryChart.self_consumption'],
          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
          ],
          db_fields: ['battery_net_flow'],
          devID: 'bizarre-marshmallow',
          devPath: 'member-energy->default->batteryChart',
        },
        {
          order: 10,
          className: 'grid-xs-12 grid-lg-6 px-1 py-0_5',
          env: 'web',
          id: 'areaChartSelfConsumption',
          title: 'widgets.areaChartSelfConsumptionCommunity.title',
          type: 'areaChart',
          subtype: 'areaChart',
          gradientBorder: false,
          view: 'community',
          graphKeys: ['import_total', 'export_total', 'total_shared'],
          colors: ['import', 'export', 'total_shared'],
          devID: 'mirthful-dragon',
          devPath: 'member-energy->default->areaChartSelfConsumption',
        },
        {
          order: 11,
          className: 'grid-12 mt-0_5 py-0_5 px-1',
          type: 'horizontalChart',
          gradientBorder: false,
          subtype: 'horizontalChart',
          titleCallback: 'HORIZONTAL_CHART',
          id: 'horizontalChart',
          context: 'energy',
          rankingKpi: 'consumption',
          rankingKpiName: [
            'widgets.horizontalChart.energy.consumption',
            'widgets.horizontalChart.energy.production',
          ],
          graphKeys: [
            [
              'self_consumption_direct',
              'self_consumption_battery',
              'from_shared',
              'from_grid',
            ],
            [
              'self_consumption_direct',
              'production_to_battery',
              'to_shared',
              'to_grid',
            ],
          ],
          combinedKeys: ['from_shared', 'from_grid'],
          buttons: [
            'widgets.horizontalChart.energy.self_consumption_direct',
            'widgets.horizontalChart.energy.self_consumption_battery',
            'widgets.horizontalChart.energy.from_shared',
            'widgets.horizontalChart.energy.from_grid',
          ],
          colors: [
            {
              color: 'self_consumption',
              colorShade: '',
            },
            {
              color: 'total_battery',
              colorShade: '',
            },
            {
              color: 'total_shared',
              colorShade: '',
            },
            {
              color: 'total_grid',
              colorShade: '60',
            },
          ],
          title: 'widgets.horizontalChart.energy.title',
          devID: 'hysterical-penguin',
          devPath: 'member-energy->default->horizontalChart',
        },
      ],
      'org:admin': {
        consumer: [
          {
            id: 'selfSufficiencyCard',
            keep: false,
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
          },
          {
            id: 'pollutionCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumptionSite',
            keep: false,
          },

          {
            id: 'totalConsumptionCard',
            keep: false,
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
          },
          {
            id: 'statsOverviewProduction',
            keep: false,
          },
          {
            id: 'siteStatsOverviewConsumption',
            keep: false,
          },
          {
            id: 'memberStatsOverviewConsumption',
            keep: false,
          },
          {
            id: 'memberStatsOverviewProduction',
            keep: false,
          },
          {
            id: 'memberSharedEnergyCard',
            keep: false,
          },
          {
            id: 'memberPollutionCard',
            keep: false,
          },
          {
            keep: false,
            id: 'areaChartSelfConsumption',
          },
          {
            keep: false,
            id: 'batteryChart',
          },

          {
            order: 1,
            className:
              'grid-xs-12 grid-md-6 pt-xs-0_5 pb-lg-0_5 responsiveBackground__xs responsiveBackground__sm responsiveBackground__md',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: ['from_shared', 'from_grid'],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'jubilant-cactus',
            devPath:
              'site-energy->org:admin->consumer->siteStatsOverviewConsumption',
          },

          {
            order: 3,
            className:
              'grid-xs-12 grid-md-6 pt-md-0_5 pb-xs-0_5 responsiveBackground__md',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            forceHeight: true,
            devID: 'cannibal-bushmeat',
            devPath: 'site-energy->org:admin->consumer->map',
          },

          {
            order: 4,
            className: 'grid-xs-12 p-1 pt-xs-0 pb-xs-0_5 pt-xs-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            devID: 'clumsy-guitar',
            devPath: 'site-energy->org:admin->consumer->pollutionCard',
          },

          {
            order: 5,
            className: 'grid-12 p-1 pt-xs-0_5',
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBarKwick',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'rowdy-gorilla',
            devPath: 'site-energy->org:admin->consumer->consumptionStackBar',
          },
          {
            id: 'horizontalChart',
            keep: false,
          },
          {
            order: 6,
            className: 'grid-12 px-1 py-0_5',

            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            titleCallback: 'HORIZONTAL_CHART',
            context: 'energy',
            rankingKpi: 'import_total',
            graphKeys: [['from_shared', 'from_grid']],
            kpiNameLabels: ['import_total'],
            combinedKeys: [],
            tooltipColors: [
              [
                {
                  color: 'from_shared',
                  colorShade: '',
                },
                {
                  color: 'from_grid',
                  colorShade: '',
                },
              ],
            ],
            rankingKpiName: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            buttons: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'peculiar-carpet',
            devPath: 'member-energy->org:admin->consumer->horizontalChart',
          },
        ],
        producer: [
          {
            id: 'memberStatsOverviewConsumption',
            keep: false,
          },
          {
            id: 'memberSelfSufficiencyCard',
            keep: false,
          },
          {
            id: 'memberSharedEnergyCard',
            keep: false,
          },
          {
            id: 'memberPollutionCard',
            keep: false,
          },
          {
            id: 'consumptionStackBar',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumption',
            keep: false,
          },

          {
            order: 1,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0 pb-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalProductionCard',
            id: 'totalProductionCard',
            totalValue: 'production',
            icon: 'house_export',
            descriptionValue: 'production',
            descriptionType: 'label',
            description: 'widgets.totalProductionCard.description.producer',
            devID: 'turbulent-cat',
            devPath: 'member-energy->org:admin->producer->totalProductionCard',
          },
          {
            order: 2,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0 pb-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.rate_consumption',
                value: ['from_shared', 'from_grid_from_shared_rate'],
              },
              {
                key: 'widgets.sharedEnergyCard.description.rate_production',
                value: ['to_shared', 'to_grid_to_shared_rate'],
              },
            ],
            devID: 'rampaging-cat',
            devPath: 'member-energy->org:admin->producer->sharedEnergyCard',
          },

          {
            id: 'pollutionCard',
            keep: false,
          },
          {
            order: 3,
            className:
              'grid-xs-12 grid-md-6 grid-lg-6 px-1 pt-xs-0 pb-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCardKwick',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'daring-xylophone',
            devPath: 'member-energy->org:admin->producer->pollutionCard',
          },
          {
            order: 4,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 px-1 pt-xs-0 pb-0_5 pl-lg-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'member-energy',
            devID: 'mystical-cabbage',
            devPath: 'member-energy->org:admin->producer->map',
          },
          {
            order: 5,
            className: 'grid-12 px-1 py-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'frisky-hamburger',
            devPath: 'member-energy->org:admin->producer->productionStackBar',
          },
          {
            order: 6,
            className: 'grid-12 px-1 py-0_5',
            type: 'horizontalChart',
            gradientBorder: false,
            subtype: 'horizontalChart',
            titleCallback: 'HORIZONTAL_CHART',
            id: 'horizontalChart',
            context: 'energy',
            rankingKpi: 'to_shared',
            graphKeys: [['to_shared'], ['to_grid']],
            combinedKeys: [],
            rankingKpiName: ['widgets.horizontalChart.energy.to_grid'],
            buttons: [
              'widgets.horizontalChart.energy.to_shared',
              'widgets.horizontalChart.energy.to_grid',
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'peculiar-lighthouse',
            devPath: 'member-energy->org:admin->producer->horizontalChart',
          },
        ],
        consumer_producer: [
          {
            id: 'memberSelfSufficiencyCard',
            keep: false,
          },
          {
            id: 'memberPollutionCard',
            keep: false,
          },
          {
            id: 'memberSharedEnergyCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'horizontalChart',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumption',
            keep: false,
          },

          {
            order: 4,
            className: 'grid-xs-12 grid-md-6 grid-lg-3',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalConsumptionCard',
            id: 'totalConsumptionCard',
            totalValue: 'consumption',
            icon: 'house_import',
            descriptionValue: 'consumption',
            descriptionType: 'label',
            description: 'widgets.totalConsumptionCard.description.consumer',
            devID: 'oddball-giraffe',
            devPath:
              'member-energy->org:admin->consumer_producer->totalConsumptionCard',
          },
          {
            order: 5,
            env: 'web',
            className: 'grid-xs-12 grid-md-6 grid-lg-3',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalProductionCard',
            id: 'totalProductionCard',
            totalValue: 'production',
            icon: 'house_export',
            descriptionValue: 'production',
            descriptionType: 'label',
            description: 'widgets.totalProductionCard.description.producer',
            devID: 'glowing-cactus',
            devPath:
              'member-energy->org:admin->consumer_producer->totalProductionCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-md-6 grid-lg-3',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.prosumer.key_1',
                value: ['from_shared', 'from_grid_from_shared_rate'],
              },
              {
                key: 'widgets.sharedEnergyCard.description.prosumer.key_2',
                value: ['to_shared', 'to_grid_to_shared_rate'],
              },
            ],
            devID: 'eccentric-espresso',
            devPath:
              'member-energy->org:admin->consumer_producer->sharedEnergyCard',
          },
          {
            id: 'pollutionCard',
            keep: false,
          },
          {
            order: 7,
            className: 'grid-xs-12 grid-md-6 grid-lg-6 px-1 py-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCardKwick',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'wild-koala',
            devPath:
              'member-energy->org:admin->consumer_producer->pollutionCard',
          },

          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'nutty-penguin',
            devPath:
              'member-energy->org:admin->consumer_producer->consumptionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-glove',
            devPath:
              'member-energy->org:admin->consumer_producer->productionStackBar',
          },
          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 12,
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDoubleKwick',
            titleCallback: 'HORIZONTAL_CHART',
            context: 'energy',
            rankingKpi: 'import',
            kpiNameLabels: ['import_total', 'export_total'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.import_total',
              'widgets.horizontalChart.energy.export_total',
            ],
            graphKeys: [
              ['from_shared', 'from_grid', 'to_shared', 'to_grid'],
              ['from_shared', 'from_grid', 'to_shared', 'to_grid'],
            ],
            combinedKeys: [],
            buttons: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
              'widgets.horizontalChart.energy.to_shared',
              'widgets.horizontalChart.energy.to_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'from_shared',
                  colorShade: '',
                },
                {
                  color: 'from_grid',
                  colorShade: '',
                },
                {
                  color: 'to_shared',
                  colorShade: '',
                },
                {
                  color: 'to_grid',
                  colorShade: '',
                },
              ],
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'dorky-lemonade',
            devPath: 'member-energy->default->horizontalChartDouble',
          },
        ],
        prosumer: [
          {
            id: 'memberPollutionCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'horizontalChart',
            keep: false,
          },
          {
            id: 'batteryChart',
            keep: false,
          },

          {
            id: 'memberSharedEnergyCard',
            keep: false,
          },
          {
            id: 'pollutionCard',
            keep: false,
          },

          {
            id: 'rowsWrapper',
            type: 'rowsWrapper',
            devID: 'wild-wrapper',
            className: 'grid-xs-12',
            order: 6,
            devPath: 'member-energy->org:admin->prosumer->rowsWrapper',
            items: [
              {
                order: 5,
                className:
                  'grid-xs-12 grid-md-6 px-1 py-xs-0_5 pb-0_5 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                subtype: 'memberSharedEnergyCard',
                id: 'memberSharedEnergyCard',
                totalValue: 'total_shared',
                icon: 'shared_energy',
                descriptionType: 'label',
                description: 'widgets.sharedEnergyCard.description.default',
                devID: 'rampaging-whale',
                devPath:
                  'member-energy>org:admin->prosumer->memberSharedEnergyCard',
              },
              {
                order: 7,
                className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,

                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCardKwick',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.producer.line_1',
                  line_2: 'widgets.pollutionCard.description.producer.line_2',
                },
                devID: 'wild-mannequin',
                devPath:
                  'member-energy->org:admin->consumer_producer->pollutionCard',
              },
            ],
          },

          {
            id: 'consumptionStackBar',
            keep: false,
          },

          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'kwickConsumptionStackBar',
            totalValue: 'import_total',
            combinedKeys: null,
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'nutty-panchin',
            devPath:
              'member-energy->org:admin->consumer_producer->consumptionStackBar',
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 px-1 py-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'kwickProductionStackBar',
            totalValue: 'export_total',
            kpiContext: 'energy',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-melina',
            devPath:
              'member-energy->org:admin->consumer_producer->productionStackBar',
          },
          {
            order: 10,
            className: 'grid-xs-12 px-1 py-0_5',
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'community',
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devID: 'mirthful-snail',
            devPath: 'member-energy->default->areaChartSelfConsumption',
          },
          // {
          //   id: 'horizontalChartDouble',
          //   keep: false,
          // },
          {
            order: 11,
            className: 'grid-12 px-1 py-0_5',
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            titleCallback: 'HORIZONTAL_CHART',
            context: 'energy',
            rankingKpi: 'import_total',
            kpiNameLabels: ['import_total', 'export_total'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.import_total',
              'widgets.horizontalChart.energy.export_total',
            ],
            graphKeys: [
              ['from_shared', 'from_grid', 'to_shared', 'to_grid'],
              ['from_shared', 'from_grid', 'to_shared', 'to_grid'],
            ],
            combinedKeys: [],
            buttons: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
              'widgets.horizontalChart.energy.to_shared',
              'widgets.horizontalChart.energy.to_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'from_shared',
                  colorShade: '',
                },
                {
                  color: 'from_grid',
                  colorShade: '',
                },
              ],
              [
                {
                  color: 'to_shared',
                  colorShade: '',
                },
                {
                  color: 'to_grid',
                  colorShade: '',
                },
              ],
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'eccentric-cherry',
            devPath:
              'member-energy->org:admin->consumer_producer->horizontalChartDouble',
          },
        ],
        prosumage: [
          {
            id: 'horizontalChart',
            keep: false,
          },

          {
            order: 1,
            className: 'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_total_shared_rate',
                label: 'widgets.memberStatsOverviewConsumption.from_shared',
              },
              {
                key: 'self_consumption_battery',
                percentage: 'import_self_consumption_battery_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.memberStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'self_consumption_battery',
              'from_grid',
            ],
            title: 'widgets.memberStatsOverviewConsumption.title',
            devID: 'quirky-hedgehog',
            devPath:
              'member-energy->org:admin->prosumage->memberStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'to_shared',
                percentage: 'export_total_total_shared_rate',
                label: 'widgets.memberStatsOverviewProduction.to_shared',
              },
              {
                key: 'production_battery',
                percentage: 'production_battery_rate',
                label:
                  'widgets.memberStatsOverviewProduction.production_battery',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label: 'widgets.memberStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: ['to_shared', 'production_to_battery', 'to_grid'],
            title: 'widgets.memberStatsOverviewProduction.title',
            devID: 'unruly-penguin',
            devPath:
              'member-energy->org:admin->prosumage->memberStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            devID: 'vivacious-dragon',
            devPath: 'member-energy->org:admin->prosumage->map',
          },

          {
            id: 'memberSelfSufficiencyCard',
            keep: false,
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pt-lg-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberSharedEnergyCard',
            id: 'memberSharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.rate_consumption',
                value: ['from_shared', 'from_grid_from_shared_rate'],
              },
              {
                key: 'widgets.sharedEnergyCard.description.rate_production',
                value: ['to_shared', 'to_grid_to_shared_rate'],
              },
            ],
            devID: 'waggish-drum',
            devPath:
              'member-energy->org:admin->prosumage->memberSharedEnergyCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pt-lg-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberPollutionCard',
            id: 'memberPollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            kpiContext: 'ancillary',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.memberPollutionCard.description.prosumer.line_1',
              line_2: 'widgets.memberPollutionCard.description.prosumer.line_2',
            },
            devID: 'quirky-cactus',
            devPath: 'member-energy->org:admin->prosumage->memberPollutionCard',
          },
          {
            order: 7,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'angry-obelisk',
            devPath: 'member-energy->org:admin->prosumage->consumptionStackBar',
          },
          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'fantastic-espresso',
            devPath: 'member-energy->org:admin->prosumage->productionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            id: 'batteryChart',
            title: 'widgets.batteryChart.title',
            type: 'batteryChart',
            gradientBorder: false,
            context: 'member',
            buttons: ['widgets.batteryChart.self_consumption'],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
            ],
            db_fields: ['battery_net_flow'],
            devID: 'romantic-yogurt',
            devPath: 'member-energy->org:admin->prosumage->batteryChart',
          },
          {
            order: 10,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'community',
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devID: 'zesty-penguin',
            devPath:
              'member-energy->org:admin->prosumage->areaChartSelfConsumption',
          },
          {
            order: 11,
            className: 'grid-12 px-1 py-0_5',
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDouble',
            titleCallback: 'HORIZONTAL_CHART',
            context: 'energy',
            rankingKpi: 'import_total',
            kpiNameLabels: ['import_total', 'export_total'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.import_total',
              'widgets.horizontalChart.energy.export_total',
            ],
            graphKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            combinedKeys: [
              ['from_shared', 'from_grid'],
              ['to_shared', 'to_grid'],
            ],
            buttons: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
              'widgets.horizontalChart.energy.to_shared',
              'widgets.horizontalChart.energy.to_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'from_shared',
                  colorShade: '',
                },
                {
                  color: 'from_grid',
                  colorShade: '',
                },
                {
                  color: 'to_shared',
                  colorShade: '',
                },
                {
                  color: 'to_grid',
                  colorShade: '60',
                },
              ],
              [
                {
                  color: 'from_shared',
                  colorShade: '',
                },
                {
                  color: 'from_grid',
                  colorShade: '',
                },
                {
                  color: 'to_shared',
                  colorShade: '',
                },
                {
                  color: 'to_grid',
                  colorShade: '60',
                },
              ],
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'nocturnal-pencil',
            devPath:
              'member-energy->org:admin->prosumage->horizontalChartDouble',
          },
        ],
        prosumer_battery: [
          {
            id: 'horizontalChart',
            keep: false,
          },

          {
            order: 1,
            env: 'web',
            className: 'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_total_shared_rate',
                label: 'widgets.memberStatsOverviewConsumption.from_shared',
              },
              {
                key: 'self_consumption_battery',
                percentage: 'import_self_consumption_battery_rate',
                label:
                  'widgets.memberStatsOverviewConsumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.memberStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'self_consumption_battery',
              'from_grid',
            ],
            title: 'widgets.memberStatsOverviewConsumption.title',
            devID: 'quirky-toilet',
            devPath:
              'member-energy->org:admin->prosumage->memberStatsOverviewConsumption',
          },
          {
            order: 2,
            env: 'web',
            className: 'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'memberStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'member',
            graphDataKeys: [
              {
                key: 'to_shared',
                percentage: 'export_total_total_shared_rate',
                label: 'widgets.memberStatsOverviewProduction.to_shared',
              },
              {
                key: 'production_battery',
                percentage: 'production_battery_rate',
                label:
                  'widgets.memberStatsOverviewProduction.production_battery',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label: 'widgets.memberStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: ['to_shared', 'production_battery', 'to_grid'],
            title: 'widgets.memberStatsOverviewProduction.title',
            devID: 'unholy-penguin',
            devPath:
              'member-energy->org:admin->prosumage->memberStatsOverviewProduction',
          },
          {
            className: 'grid-xs-12 grid-lg-4 pb-xs-1 pb-lg-0_5',
            order: 3,
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            devID: 'plucky-nugget',
            devPath: 'member-energy->org:admin->prosumage->map',
          },
          {
            id: 'memberSelfSufficiencyCard',
            keep: false,
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pt-lg-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberSharedEnergyCard',
            id: 'memberSharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.rate_consumption',
                value: ['from_shared', 'from_grid_from_shared_rate'],
              },
              {
                key: 'widgets.sharedEnergyCard.description.rate_production',
                value: ['to_shared', 'to_grid_to_shared_rate'],
              },
            ],
            devID: 'waggish-sitar',
            devPath:
              'member-energy->org:admin->prosumage->memberSharedEnergyCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pt-lg-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'memberPollutionCard',
            id: 'memberPollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            kpiContext: 'ancillary',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.memberPollutionCard.description.prosumer.line_1',
              line_2: 'widgets.memberPollutionCard.description.prosumer.line_2',
            },
            devID: 'quirky-orange',
            devPath: 'member-energy->org:admin->prosumage->memberPollutionCard',
          },
          {
            order: 7,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'plucky-pumpkin',
            devPath: 'member-energy->org:admin->prosumage->consumptionStackBar',
          },
          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'plucky-raccoon',
            devPath: 'member-energy->org:admin->prosumage->productionStackBar',
          },
          {
            order: 9,

            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            id: 'batteryChart',
            title: 'widgets.batteryChart.title',
            type: 'batteryChart',
            gradientBorder: false,
            context: 'member',
            buttons: ['widgets.batteryChart.self_consumption'],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
            ],
            db_fields: ['battery_net_flow'],
            devID: 'catholic-pineapple',
            devPath: 'member-energy->org:admin->prosumage->batteryChart',
          },
          {
            order: 10,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            env: 'web',
            id: 'areaChartSelfConsumption',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'community',
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devID: 'plucky-sprout',
            devPath:
              'member-energy->org:admin->prosumage->areaChartSelfConsumption',
          },
          {
            className: 'grid-12 p-1 py-xs-0_5',
            order: 12,
            type: 'horizontalChartDouble',
            gradientBorder: false,
            subtype: 'horizontalChartDouble',
            id: 'horizontalChartDoubleKwick',
            titleCallback: 'HORIZONTAL_CHART',
            context: 'energy',
            rankingKpi: 'import',
            kpiNameLabels: ['import_total', 'export_total'],
            rankingKpiName: [
              'widgets.horizontalChart.energy.import_total',
              'widgets.horizontalChart.energy.export_total',
            ],
            graphKeys: [
              ['from_shared', 'from_grid', 'to_shared', 'to_grid'],
              ['from_shared', 'from_grid', 'to_shared', 'to_grid'],
            ],
            combinedKeys: [],
            buttons: [
              'widgets.horizontalChart.energy.from_shared',
              'widgets.horizontalChart.energy.from_grid',
              'widgets.horizontalChart.energy.to_shared',
              'widgets.horizontalChart.energy.to_grid',
            ],
            tooltipColors: [
              [
                {
                  color: 'from_shared',
                  colorShade: '',
                },
                {
                  color: 'from_grid',
                  colorShade: '',
                },
                {
                  color: 'to_shared',
                  colorShade: '',
                },
                {
                  color: 'to_grid',
                  colorShade: '',
                },
              ],
            ],
            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.horizontalChart.energy.title',
            devID: 'frisky-dandelion',
            devPath: 'member-energy->default->horizontalChartDouble',
          },
        ],
      },
    },
  },

  // MEMBER ECONOMICS
  {
    name: 'member-economics',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'EconomicsKpiMemberResolver',
        'MemberResolver',
        'EconomicsMemberRankingResolver',
        'EconomicsCustomKpiMemberResolver',
      ],
    },
    widgets: {
      default: [
        {
          className: 'grid-12 mb-10 mb-lg-6_5',
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'member-economics',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'eccentric-glove',
          devPath: 'member-economics->default->headerWeb',
        },

        {
          order: 1,
          className: 'grid-xs-12 ',
          id: 'rowsWrapper',
          type: 'rowsWrapper',
          devID: 'boring-wrapper',
          devPath: 'member-economics->default->rowsWrapper',
          items: [
            {
              className: 'grid-12 grid-lg-6 p-1 pb-xs-0_5 pt-xs-0_5 pr-lg-0_5',
              order: 1,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'memberCostsCard',
              id: 'memberCostsCard',
              totalValue: 'total_costs',
              icon: 'bill_no currency_solid',
              descriptionType: 'dynamic-label',
              descriptionNoData:
                'widgets.memberCostsCard.description.default_no_data',
              additionalFields: [
                {
                  field: 'community_costs',
                  label: 'widgets.memberCostsCard.community_costs',
                },
                {
                  field: 'other_costs',
                  label: 'widgets.memberCostsCard.other_costs',
                },
              ],
              description: 'widgets.memberCostsCard.description.default',
              descriptionCallback: 'memberTotalCosts',
              kpiContext: 'economics',
              devID: 'terrific-penguin',
              devPath: 'member-economics->default->memberCostsCard',
              drawerConfig: {
                titleKey: 'drawers.memberCostsCard.title',
                descriptionKey: 'drawers.memberCostsCard.description',
                listTitleKey: 'drawers.memberCostsCard.list_title',
                listTitleCostsKey: 'drawers.memberCostsCard.list_title_costs',
              },
            },
            {
              className: 'grid-12 grid-lg-6 p-1 pb-xs-0_5 pt-xs-0_5 pl-sm-0_5',
              order: 2,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'memberBenefitsCard',
              id: 'memberBenefitsCard',
              totalValue: 'total_benefits',
              icon: 'savings',
              descriptionType: 'dynamic-label',
              additionalFields: [
                {
                  field: 'revenues',
                  label: 'widgets.memberBenefitsCard.revenues',
                },
                {
                  field: 'savings',
                  label: 'widgets.memberBenefitsCard.savings',
                },
              ],
              description: 'widgets.memberBenefitsCard.description.default',
              descriptionCallback: 'memberTotalEstimatedBenefits',
              descriptionNoData:
                'widgets.memberBenefitsCard.description.default_no_data',
              devID: 'glorious-armadillo',
              devPath: 'member-economics->default->memberBenefitsCard',
              drawerConfig: {
                titleKey: 'drawers.memberTotalEstimatedBenefits.title',
                descriptionKey:
                  'drawers.memberTotalEstimatedBenefits.description',
                listTitleKey: 'drawers.memberTotalEstimatedBenefits.list_title',
                listTitleCostsKey:
                  'drawers.memberTotalEstimatedBenefits.list_title_savings',
              },
            },
          ],
        },

        {
          className: 'grid-12 grid-lg-6 p-1 py-xs-0_5 pt-xs-0 pr-lg-0_5',
          order: 4,
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'costsStackBar',
          id: 'costsStackBar',
          totalValue: 'total_costs',
          graphKeys: [
            {
              key: 'community_costs',
              color: 'cost_1',
              combined: false,
            },
            {
              key: 'other_costs',
              color: 'cost_2',
              combined: false,
            },
          ],
          colors: ['cost_1', 'cost_2'],
          title: 'widgets.costsStackBar.title',
          devID: 'radiant-brick',
          hideWhen: 'HIDE_ON_KWICK_DAYS',
          devPath: 'member-economics->default->costsStackBar',
        },

        {
          className: 'grid-12 grid-lg-6 p-1 py-xs-0_5 pt-xs-0 pl-lg-0_5',
          order: 5,
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'benefitsStackBar',
          id: 'benefitsStackBar',
          totalValue: 'total_benefits',
          graphKeys: [
            {
              key: 'revenues',
              color: 'revenues',
              combined: false,
            },
            {
              key: 'savings',
              color: 'savings',
              combined: false,
            },
          ],
          colors: ['revenues', 'savings'],
          title: 'widgets.benefitsStackBar.title',
          hideWhen: 'HIDE_ON_KWICK_DAYS',
          devID: 'angry-lighter',
          devPath: 'member-economics->default->benefitsStackBar',
        },
        {
          className: 'grid-12 p-1 py-xs-0_5',
          order: 6,
          type: 'horizontalChart',
          gradientBorder: false,
          subtype: 'horizontalChart',
          titleCallback: 'HORIZONTAL_CHART',
          id: 'horizontalChartEconomics',
          entity: 'member',
          context: 'economics',
          rankingKpi: 'total_costs',
          rankingKpiName: 'widgets.horizontalChart.economics.total_costs',
          graphKeys: ['community_costs', 'other_costs'],
          combinedKeys: [],
          buttons: [
            'widgets.horizontalChart.economics.community_costs',
            'widgets.horizontalChart.economics.other_costs',
          ],
          colors: [
            {
              color: 'cost_1',
              colorShade: '',
            },
            {
              color: 'cost_2',
              colorShade: '',
            },
          ],
          title: 'widgets.horizontalChart.economics.title',
          devID: 'ferocious-avocado',
          devPath: 'member-economics->default->horizontalChart',
        },
      ],
    },
  },

  // SITE
  {
    name: 'site',
    needsAuth: true,
    needsID: true,
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    sideBar: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'SiteOverviewResolver',
        'EnergyKpiSiteResolver',
        'EconomicsKpiSiteResolver',
        'KwickInvoicesResolver',
      ],
      // FLEXO-6066: end-user-only resolver for the consolidated /site page — the
      // CO2 (ancillary) pollution card. Never run for admin/supervisor.
      'org:end_user': ['AncillaryKpiSiteResolver', 'EconomicsCustomKpiSiteResolver'],
    },
    widgets: {
      'org:end_user': {
        consumer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'sitePaymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'site',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-capsule',
            devPath: 'site->org:end_user->consumer->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'plucky-otter',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 pt-xs-0 pb-1',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            forceHeight: true,
            id: 'map',
            devID: 'plucky-pebble',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 3,
            className: 'grid-xs-12',
            items: [
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteCostsCard',
                id: 'siteCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.siteCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.siteCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.siteCostsCard.other_costs',
                  },
                ],
                description: 'widgets.siteCostsCard.description.default',
                descriptionCallback: 'siteTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.siteCostsCard.title',
                  descriptionKey: 'drawers.siteCostsCard.description.default',
                  listTitleKey: 'drawers.siteCostsCard.list_title',
                  listTitleCostsKey: 'drawers.siteCostsCard.list_title_costs',
                },
                devID: 'plucky-lantern',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteBenefitsCard',
                id: 'siteBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.siteBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.siteBenefitsCard.savings',
                  },
                ],
                description: 'widgets.siteBenefitsCard.description.default',
                descriptionNoData: 'widgets.siteBenefitsCard.description.default_no_data',
                descriptionCallback: 'SiteTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.title',
                  descriptionKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.description',
                  listTitleKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title',
                  listTitleCostsKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title_savings',
                },
                devID: 'plucky-comet',
              },
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'plucky-walrus',
              },
            ],
          },
          {
            order: 4,
            className: 'grid-xs-12 px-1 ',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'plucky-pretzel',
          },
        ],
        producer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'sitePaymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'site',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-harbor',
            devPath: 'site->org:end_user->producer->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'plucky-muffin',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 pt-xs-0 pb-1',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            forceHeight: true,
            devID: 'plucky-badger',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 3,
            className: 'grid-xs-12',
            items: [
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteCostsCard',
                id: 'siteCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.siteCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.siteCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.siteCostsCard.other_costs',
                  },
                ],
                description: 'widgets.siteCostsCard.description.default',
                descriptionCallback: 'siteTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.siteCostsCard.title',
                  descriptionKey: 'drawers.siteCostsCard.description.default',
                  listTitleKey: 'drawers.siteCostsCard.list_title',
                  listTitleCostsKey: 'drawers.siteCostsCard.list_title_costs',
                },
                devID: 'plucky-anchor',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteBenefitsCard',
                id: 'siteBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.siteBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.siteBenefitsCard.savings',
                  },
                ],
                description: 'widgets.siteBenefitsCard.description.default',
                descriptionNoData: 'widgets.siteBenefitsCard.description.default_no_data',
                descriptionCallback: 'SiteTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.title',
                  descriptionKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.description',
                  listTitleKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title',
                  listTitleCostsKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title_savings',
                },
                devID: 'plucky-turnip',
              },
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'plucky-quokka',
              },
            ],
          },
          {
            order: 4,
            className: 'grid-xs-12 px-1 ',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'plucky-satchel',
          },
        ],
        prosumer: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'sitePaymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'site',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-keystone',
            devPath: 'site->org:end_user->prosumer->headerWebEndUser',
          },
          // FLEXO-6088 #3: prosumer needs TWO donuts side by side (Imported + Exported).
          // Replace the former map slot with the production/export donut so layout matches Figma.
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6 grid-lg-4',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'plucky-domino',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 grid-lg-4',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'to_shared',
                percentage: 'export_total_to_shared_rate',
                label: 'widgets.siteStatsOverviewProduction.to_shared',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label: 'widgets.siteStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: [
              'to_shared',
              'to_grid',
            ],
            title: 'widgets.siteStatsOverviewProduction.title',
            devID: 'plucky-sundial',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'community',
            devID: 'nocturnal-cinnamon',
            forceHeight: true,
            devPath: 'site-energy->org:end_user->prosumer->map',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 4,
            className: 'grid-xs-12 pt-1',
            items: [
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-md-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteCostsCard',
                id: 'siteCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.siteCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.siteCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.siteCostsCard.other_costs',
                  },
                ],
                description: 'widgets.siteCostsCard.description.default',
                descriptionCallback: 'siteTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.siteCostsCard.title',
                  descriptionKey: 'drawers.siteCostsCard.description.default',
                  listTitleKey: 'drawers.siteCostsCard.list_title',
                  listTitleCostsKey: 'drawers.siteCostsCard.list_title_costs',
                },
                devID: 'plucky-noodle',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pl-md-0_5 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteBenefitsCard',
                id: 'siteBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.siteBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.siteBenefitsCard.savings',
                  },
                ],
                description: 'widgets.siteBenefitsCard.description.default',
                descriptionNoData: 'widgets.siteBenefitsCard.description.default_no_data',
                descriptionCallback: 'SiteTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.title',
                  descriptionKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.description',
                  listTitleKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title',
                  listTitleCostsKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title_savings',
                },
                devID: 'plucky-beacon',
              },
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'plucky-meerkat',
              },
            ],
          },
          // FLEXO-6088 #3: TWO charts side by side — Imported (from_shared / from_grid)
          // and Exported (to_shared / to_grid).
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-6 px-1 pb-1 pr-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'plucky-trombone',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-6 px-1 pb-1 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'plucky-anvil',
          },
          // FLEXO-6088 #3: ONE full-width shared-energy area chart (Imported / Exported /
          // Shared energy tabs driven by graphKeys).
          {
            order: 7,
            className: 'grid-xs-12 px-1 pb-1',
            env: 'web',
            id: 'areaChartSelfConsumptionSite',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devID: 'plucky-prism',
          },
        ],
        prosumage: [
          {
            id: 'rowsWrapper',
            keep: false,
          },
          {
            id: 'sitePaymentsTable',
            keep: false,
          },
          {
            id: 'parametersDetails',
            keep: false,
          },
          {
            className: 'grid-12 mb-5_5',
            type: 'headerWebEndUser',
            id: 'headerWebEndUser',
            data: {
              label: 'site',
              breadCrumbs: true,
              navigation: true,
              calendar: true,
              download: false,
              searchBar: false,
              profile: true,
            },
            devID: 'steady-marker',
            devPath: 'site->org:end_user->storage->headerWebEndUser',
          },
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'plucky-llama',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 pt-xs-0 pb-1',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            forceHeight: true,
            devID: 'plucky-cobweb',
          },
          {
            type: 'rowsWrapper',
            id: 'enduserCardsRow',
            keep: true,
            order: 3,
            className: 'grid-xs-12',
            items: [
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteCostsCard',
                id: 'siteCostsCard',
                totalValue: 'total_costs',
                icon: 'bill_no currency_solid',
                descriptionType: 'dynamic-label',
                descriptionNoData: 'widgets.siteCostsCard.description.default_no_data',
                additionalFields: [
                  {
                    field: 'community_costs',
                    label: 'widgets.siteCostsCard.community_costs',
                  },
                  {
                    field: 'other_costs',
                    label: 'widgets.siteCostsCard.other_costs',
                  },
                ],
                description: 'widgets.siteCostsCard.description.default',
                descriptionCallback: 'siteTotalCosts',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.siteCostsCard.title',
                  descriptionKey: 'drawers.siteCostsCard.description.default',
                  listTitleKey: 'drawers.siteCostsCard.list_title',
                  listTitleCostsKey: 'drawers.siteCostsCard.list_title_costs',
                },
                devID: 'plucky-radish',
              },
              {
                className: 'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-xs-0 px-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                subtype: 'siteBenefitsCard',
                id: 'siteBenefitsCard',
                totalValue: 'total_benefits',
                icon: 'savings',
                descriptionType: 'dynamic-label',
                additionalFields: [
                  {
                    field: 'revenues',
                    label: 'widgets.siteBenefitsCard.revenues',
                  },
                  {
                    field: 'savings',
                    label: 'widgets.siteBenefitsCard.savings',
                  },
                ],
                description: 'widgets.siteBenefitsCard.description.default',
                descriptionNoData: 'widgets.siteBenefitsCard.description.default_no_data',
                descriptionCallback: 'SiteTotalEstimatedBenefits',
                kpiContext: 'economics',
                drawerConfig: {
                  kpiContext: 'economics',
                  titleKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.title',
                  descriptionKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.description',
                  listTitleKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title',
                  listTitleCostsKey: 'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title_savings',
                },
                devID: 'plucky-hamster',
              },
              {
                className: 'grid-xs-12 grid-lg-4 p-1 pt-xs-0 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.consumer.line_1',
                  line_2: 'widgets.pollutionCard.description.consumer.line_2',
                },
                devID: 'plucky-igloo',
              },
            ],
          },
          {
            order: 4,
            className: 'grid-xs-12 px-1 ',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              'from_shared',
              'from_grid',
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'plucky-jellyfish',
          },
        ],
      },
      default: [
        {
          order: 0,
          className: 'grid-12 mb-6',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'site',
            breadCrumbs: true,
            navigation: true,
            calendar: 'hidden',
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'happy-shoe',
          devPath: 'site->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 ',
          id: 'rowsWrapper',
          type: 'rowsWrapper',
          devID: 'daring-wrapper',
          devPath: 'site->default->rowsWrapper',
          items: [
            {
              order: 1,
              className:
                'grid-xs-12 grid-md-6 grid-lg-4 p-1 pt-md-0 pb-xs-0_5 pr-md-0_5',
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'siteCostsCard',
              id: 'siteCostsCard',
              isOverview: true,
              totalValue: 'total_costs',
              icon: 'bill_no currency_solid',
              descriptionCallback: 'siteEconomics',
              descriptionType: 'dynamic-label-inline',
              kpiContext: 'economics',
              description: 'widgets.siteCostsCard.description.default',
              descriptionNoData:
                'widgets.siteCostsCard.description.default_no_data',
              devID: 'cannibal-firecracker',
              devPath: 'site->default->siteCostsCard',

              additionalFields: [
                {
                  field: 'revenues',
                  label: 'widgets.siteCostsCard.revenues_inline',
                },
                {
                  field: 'savings',
                  label: 'widgets.siteCostsCard.savings_inline',
                },
              ],
              drawerConfig: {
                titleKey:
                  'drawers.SiteTotalEstimatedBenefitsDrawerContent.title',
                descriptionKey:
                  'drawers.SiteTotalEstimatedBenefitsDrawerContent.description',
                listTitleKey:
                  'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title',
                listTitleSavingsKey:
                  'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title_savings',
              },
            },
            {
              env: 'web',
              order: 2,
              className:
                'grid-xs-12 grid-md-6 grid-lg-4 p-1 py-xs-0_5 pt-md-0 pl-md-0_5 pr-md-1 pr-lg-0_5',
              type: 'card',
              gradientBorder: false,
              subtype: 'siteEnergyFlowsCard',
              id: 'siteEnergyFlowsCard',
              isOverview: true,
              icon: 'lightning',
              descriptionCallback: 'siteEnergy',
              descriptionType: 'siteType[label+value]',
              // totalValue: 'import_total',
              description: {
                default: [
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.import_total',
                    value: 'import_total',
                  },
                ],
                consumer: [
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.import_total',
                    value: 'import_total',
                  },
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.total_shared',
                    value: 'total_shared',
                  },
                ],
                producer: [
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.total_shared',
                    value: 'total_shared',
                  },
                ],
                prosumage: [
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.import_total',
                    value: 'import_total',
                  },
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.export_total',
                    value: 'export_total',
                  },
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.total_shared',
                    value: 'total_shared',
                  },
                ],
                prosumer: [
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.import_total',
                    value: 'import_total',
                  },
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.export_total',
                    value: 'export_total',
                  },
                  {
                    key: 'widgets.siteEnergyFlowsCard.description.default.total_shared',
                    value: 'total_shared',
                  },
                ],
              },
              devID: 'wild-tangerine',
              devPath: 'site->default->siteEnergyFlowsCard',
            },
            {
              env: 'web',
              order: 3,
              className:
                'grid-xs-12 grid-lg-4 p-1 pb-xs-0_5 pt-xs-0_5 pt-lg-0 pl-lg-0_5 pr-lg-1',
              type: 'map',
              gradientBorder: false,
              id: 'map',
              context: 'site',
              devID: 'giddy-jigsaw',
              devPath: 'site->default->map',
            },
          ],
        },

        {
          order: 4,
          className: 'grid-xs-12 grid-xl-9 p-1 pt-xs-0_5 pt-xl-0 pr-xl-0_5 order-xs-4 order-xl-3',
          type: 'sitePaymentsTable',
          id: 'sitePaymentsTable',
          devID: 'unruly-narwhal',
          devPath: 'site->default->sitePaymentsTable',
          showTable: true,
        },
        {
          order: 5,
          className:
            'grid-xs-12 grid-xl-3 p-1 py-xs-0_5 pl-xl-0_5 order-xs-3 order-xl-4 flex flex-column flex-sm-row flex-xl-column community-layout__sidebar-pair',
          devID: 'glossy-stone',
          devPath: 'site->default->parametersDetails',
          id: 'parametersDetails',
          items: [
            {
              className:
                'grid-xs-12 grid-sm-6 pb-xs-1 pr-sm-0_5 pb-sm-0 grid-xl-12 pr-xl-0 pb-xl-1 community-layout__sidebar-pair-item',
              id: 'SiteDetailsParameters',
              type: 'SiteDetailsParameters',
              data: {
                title: 'widgets.siteDetailsParameters.siteName',
                externalId: 'widgets.siteDetailsParameters.id',
                joinDate: 'widgets.siteDetailsParameters.joinDate',
                // ownership: 'widgets.siteDetailsParameters.ownership',
                type: 'widgets.siteDetailsParameters.type',
                // productionBenefits:
                //   'widgets.siteDetailsParameters.productionBenefits',
              },
              devID: 'vivacious-obelisk',
              devPath: 'site->default->SiteDetailsParameters',
            },
            {
              className:
                'grid-xs-12 grid-sm-6 pl-sm-0_5 grid-xl-12 pl-xl-0 community-layout__sidebar-pair-item',
              id: 'siteMembersList',
              type: 'siteMembersList',
              devID: 'rambunctious-dinosaur',
              devPath: 'site->default->siteMembersList',
            },
          ],
        },
      ],
    },
  },
  // SITE ENERGY
  {
    name: 'site-energy',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'SiteOverviewResolver',
        'EnergyKpiSiteResolver',
        'AncillaryKpiSiteResolver',
        'EnergyCustomKpiSiteResolver',
      ],
    },
    widgets: {
      default: [
        {
          order: 0,
          className: 'grid-12  mb-9_5 mb-lg-5',
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'site-energy',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: true,
            searchBar: true,
            profile: true,
          },
          devID: 'cannibal-shoe',
          devPath: 'site-energy->default->headerWeb',
        },
        {
          id: 'selfSufficiencyCard',
          keep: false,
        },
        {
          id: 'sharedEnergyCard',
          keep: false,
        },
        {
          id: 'pollutionCard',
          keep: false,
        },
        {
          id: 'productionStackBar',
          keep: false,
        },
        {
          id: 'areaChartSelfConsumptionSite',
          keep: false,
        },

        {
          id: 'totalConsumptionCard',
          keep: false,
        },
        {
          id: 'sharedEnergyCard',
          keep: false,
        },

        {
          order: 1,
          className:
            'grid-xs-12 grid-md-6 pt-xs-0_5 pb-lg-0_5 responsiveBackground__xs responsiveBackground__sm responsiveBackground__md',
          env: 'web',
          type: 'statsOverviewWeb',
          subtype: 'statsOverviewWeb',
          id: 'siteStatsOverviewConsumption',
          totalValue: 'import_total',
          color: 'import_total',
          view: 'site',
          graphDataKeys: [
            {
              key: 'from_shared',
              percentage: 'import_total_from_shared_rate',
              label: 'widgets.siteStatsOverviewConsumption.from_shared',
            },
            {
              key: 'from_grid',
              percentage: 'import_total_from_grid_rate',
              label: 'widgets.siteStatsOverviewConsumption.from_grid',
            },
          ],
          graphColors: ['from_shared', 'from_grid'],
          title: 'widgets.siteStatsOverviewConsumption.title',
          devID: 'jubilant-papaya',
          devPath:
            'site-energy->org:admin->prosumer->siteStatsOverviewConsumption',
        },

        {
          order: 3,
          className:
            'grid-xs-12 grid-md-6 pt-xs-0_5 pb-xs-0_5 px-xs-0 responsiveBackground__md',
          env: 'web',
          type: 'map',
          gradientBorder: false,
          id: 'map',
          context: 'site-energy',
          forceHeight: true,
          devID: 'cannibal-enchilada',
          devPath: 'site-energy->default->consumer->map',
        },

        {
          order: 4,
          className: 'grid-xs-12 p-1 pt-xs-0 pb-xs-0_5 px-lg-0_5 pt-lg-0_5',
          env: 'web',
          type: 'card',
          gradientBorder: false,
          detail: false,

          kpiContext: 'ancillary',
          subtype: 'pollutionCard',
          id: 'pollutionCard',
          totalValue: 'co2_offset_kgs',
          trees: 'co2_offset_trees',
          icon: 'pollution',
          descriptionValue: 'co2_offset_trees',
          descriptionType: '{{trees}}',
          description: {
            line_1: 'widgets.pollutionCard.description.consumer.line_1',
            line_2: 'widgets.pollutionCard.description.consumer.line_2',
          },
          devID: 'clumsy-tarot',
          devPath: 'site-energy->default->consumer->pollutionCard',
        },

        {
          id: 'consumptionStackBar',
          keep: false,
        },

        {
          order: 5,
          className: 'grid-12 p-1 pt-xs-0_5',
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'consumptionStackBar',
          id: 'kwickConsumptionStackBar',
          totalValue: 'import_total',
          graphKeys: [
            {
              key: 'from_shared',
              color: 'from_shared',
              combined: false,
              base: false,
            },
            {
              key: 'from_grid',
              color: 'from_grid',
              combined: false,
              base: false,
            },
          ],
          combinedKeys: null,
          title: 'widgets.consumptionStackBar.title',
          devID: 'rowdy-spongebob',
          devPath: 'site-energy->default->consumer->consumptionStackBar',
        },
      ],
      'org:admin': {
        consumer: [
          {
            id: 'map',
            keep: false,
          },

          {
            id: 'selfSufficiencyCard',
            keep: false,
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
          },
          {
            id: 'pollutionCard',
            keep: false,
          },
          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumptionSite',
            keep: false,
          },

          {
            id: 'totalConsumptionCard',
            keep: false,
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
          },
          {
            id: 'memberStatsOverviewConsumption',
            keep: false,
          },

          {
            order: 3,
            className:
              'grid-xs-12 grid-md-6 pt-md-0_5 pb-xs-0_5 responsiveBackground__md',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'kwickMap',
            context: 'site-energy',
            forceHeight: true,
            devID: 'cannibal-rhinoceros',
            devPath: 'site-energy->org:admin->consumer->map',
          },

          {
            order: 4,
            className: 'grid-xs-12 p-1 pt-xs-0 pb-xs-0_5 pt-xs-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.consumer.line_1',
              line_2: 'widgets.pollutionCard.description.consumer.line_2',
            },
            devID: 'clumsy-drum',
            devPath: 'site-energy->org:admin->consumer->pollutionCard',
          },

          {
            order: 5,
            className: 'grid-12 p-1 pt-xs-0_5',
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'rowdy-marty',
            devPath: 'site-energy->org:admin->consumer->consumptionStackBar',
          },
        ],
        producer: [
          {
            id: 'selfSufficiencyCard',
            keep: false,
          },
          {
            id: 'sharedEnergyCard',
            keep: false,
          },
          {
            id: 'pollutionCard',
            keep: false,
          },
          {
            id: 'consumptionStackBar',
            keep: false,
          },
          {
            id: 'areaChartSelfConsumptionSite',
            keep: false,
          },

          {
            order: 1,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'totalProductionCard',
            id: 'totalProductionCard',
            totalValue: 'production',
            icon: 'house_export',
            descriptionValue: 'production',
            descriptionType: 'label',
            description: 'widgets.totalProductionCard.description.producer',
            devID: 'kooky-rhinoceros',
            devPath: 'site-energy->org:admin->producer->totalProductionCard',
          },
          {
            order: 2,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.rate_consumption',
                value: ['from_shared', 'from_grid_from_shared_rate'],
              },
              {
                key: 'widgets.sharedEnergyCard.description.rate_production',
                value: ['to_shared', 'to_grid_to_shared_rate'],
              },
            ],
            devID: 'kooky-xylophone',
            devPath: 'site-energy->org:admin->producer->sharedEnergyCard',
          },
          {
            order: 3,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.producer.line_1',
              line_2: 'widgets.pollutionCard.description.producer.line_2',
            },
            devID: 'zippy-lemonade',
            devPath: 'site-energy->org:admin->producer->pollutionCard',
          },
          {
            order: 4,
            className:
              'grid-xs-12 grid-md-6 grid-lg-3 p-1 pt-xs-0 pb-xs-0_5 pl-lg-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            devID: 'ferocious-rhinoceros',
            devPath: 'site-energy->org:admin->producer->map',
          },
          {
            order: 5,
            className: 'grid-12 p-1 pt-xs-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],
            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'kooky-iceberg',
            devPath: 'site-energy->org:admin->producer->productionStackBar',
          },
        ],
        prosumer: [
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: ['from_shared', 'from_grid'],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'jubilant-mouse',
            devPath:
              'site-energy->org:admin->prosumer->siteStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'to_shared',
                percentage: 'export_total_to_shared_rate',
                label: 'widgets.siteStatsOverviewProduction.to_shared',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label: 'widgets.siteStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: ['to_shared', 'to_grid'],
            title: 'widgets.siteStatsOverviewProduction.title',
            devID: 'wild-lighthouse',
            devPath:
              'site-energy->org:admin->prosumer->siteStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4 pb-xs-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            devID: 'nocturnal-tangerine',
            devPath: 'site-energy->org:admin->prosumer->map',
          },
          {
            id: 'selfSufficiencyCard',
            keep: false,
          },
          {
            id: 'kwickSharedEnergyCard',
            keep: false,
          },
          {
            id: 'pollutionCard',
            keep: false,
          },

          {
            id: 'rowsWrapper',
            type: 'rowsWrapper',
            className: 'grid-xs-12',
            order: 4,
            items: [
              {
                order: 5,
                className:
                  'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pb-xs-0_5 pr-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,
                subtype: 'sharedEnergyCard',
                id: 'kwickSharedEnergyCard',
                totalValue: 'total_shared',
                icon: 'shared_energy',
                descriptionType: 'label',
                description: 'widgets.sharedEnergyCard.description.default',
                // description: [
                //   {
                //     key: 'widgets.sharedEnergyCard.description.prosumer.key_1',
                //     value: ['from_shared', 'from_grid_from_shared_rate'],
                //   },
                //   {
                //     key: 'widgets.sharedEnergyCard.description.prosumer.key_2',
                //     value: ['to_shared', 'to_grid_to_shared_rate'],
                //   },
                // ],
                devID: 'kooky-breadcrumb',
                devPath:
                  'site-energy->org:admin->prosumer->kwickSharedEnergyCard',
              },
              {
                order: 6,
                className:
                  'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pb-xs-0_5 pl-lg-0_5',
                env: 'web',
                type: 'card',
                gradientBorder: false,
                detail: false,

                kpiContext: 'ancillary',
                subtype: 'pollutionCard',
                id: 'pollutionCard',
                totalValue: 'co2_offset_kgs',
                trees: 'co2_offset_trees',
                icon: 'pollution',
                descriptionValue: 'co2_offset_trees',
                descriptionType: '{{trees}}',
                description: {
                  line_1: 'widgets.pollutionCard.description.prosumer.line_1',
                  line_2: 'widgets.pollutionCard.description.prosumer.line_2',
                },
                devID: 'nutty-meatball',
                devPath: 'site-energy->org:admin->prosumer->pollutionCard',
              },
            ],
          },

          {
            id: 'consumptionStackBar',
            keep: false,
          },
          //  {
          //    id: 'kwickConsumptionStackBar',
          //    keep: false,
          //  },

          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 7,
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'kwickConsumptionStackBar',
            totalValue: 'import_total',
            combinedKeys: null,
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'clumsy-drill',
            devPath: 'site-energy->org:admin->prosumer->consumptionStackBar',
          },

          {
            id: 'productionStackBar',
            keep: false,
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'kwickProductionStackBar',
            totalValue: 'export_total',
            combinedKeys: null,
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'clumsy-tower',
            devPath: 'site-energy->org:admin->prosumer->productionStackBar',
          },
          {
            order: 10,
            className: 'grid-12 p-1 py-xs-0_5',
            env: 'web',
            id: 'kwickAreaChartSelfConsumptionSite',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devID: 'spritely-avocado',
            devPath:
              'site-energy->org:admin->prosumer->areaChartSelfConsumptionSite',
          },
        ],
        pcc: [
          {
            order: 1,
            className: 'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: ['from_shared', 'from_grid'],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'jubilant-alligator',
            devPath:
              'site-energy->org:admin->pcc->siteStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-md-6 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'to_shared',
                percentage: 'export_total_to_shared_rate',
                label: 'widgets.siteStatsOverviewProduction.to_shared',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label: 'widgets.siteStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: ['to_shared', 'to_grid'],
            title: 'widgets.siteStatsOverviewProduction.title',
            devID: 'calm-lighthouse',
            devPath: 'site-energy->org:admin->pcc->siteStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4 pb-xs-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            devID: 'nocturnal-tiger',
            devPath: 'site-energy->org:admin->pcc->map',
          },
          {
            id: 'selfSufficiencyCard',
            keep: false,
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pb-xs-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'kwickSharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.rate_consumption',
                value: ['from_shared', 'from_grid_from_shared_rate'],
              },
              {
                key: 'widgets.sharedEnergyCard.description.rate_production',
                value: ['to_shared', 'to_grid_to_shared_rate'],
              },
            ],
            devID: 'kooky-guitar',
            devPath: 'site-energy->org:admin->pcc->sharedEnergyCard',
          },
          {
            id: 'pollutionCard',
            keep: false,
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pb-xs-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCardKwick',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.prosumer.line_1',
              line_2: 'widgets.pollutionCard.description.prosumer.line_2',
            },
            devID: 'nutty-violin',
            devPath: 'site-energy->org:admin->pcc->pollutionCard',
          },

          {
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            order: 7,
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '60',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'clumsy-baby',
            devPath: 'site-energy->org:admin->pcc->consumptionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-md-6 p-1 py-xs-0_5 pl-md-0_5',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'productionStackBar',
            id: 'kwickProductionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'original-prankster',
            devPath: 'site-energy->org:admin->pcc->productionStackBar',
          },
        ],
        prosumage: [
          {
            order: 1,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewConsumption',
            totalValue: 'import_total',
            color: 'import_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'from_shared',
                percentage: 'import_total_from_shared_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_shared',
              },
              {
                key: 'self_consumption_battery',
                percentage: 'consumption_self_consumption_battery_rate',
                label:
                  'widgets.siteStatsOverviewConsumption.self_consumption_battery',
              },
              {
                key: 'from_grid',
                percentage: 'import_total_from_grid_rate',
                label: 'widgets.siteStatsOverviewConsumption.from_grid',
              },
            ],
            graphColors: [
              'from_shared',
              'self_consumption_battery',
              'from_grid',
            ],
            title: 'widgets.siteStatsOverviewConsumption.title',
            devID: 'zippy-muffin',
            devPath:
              'site-energy->org:admin->prosumage->siteStatsOverviewConsumption',
          },
          {
            order: 2,
            className: 'grid-xs-12 grid-lg-4 pb-lg-0_5',
            env: 'web',
            type: 'statsOverviewWeb',
            subtype: 'statsOverviewWeb',
            id: 'siteStatsOverviewProduction',
            totalValue: 'export_total',
            color: 'export_total',
            view: 'site',
            graphDataKeys: [
              {
                key: 'to_shared',
                percentage: 'export_total_to_shared_rate',
                label: 'widgets.siteStatsOverviewProduction.to_shared',
              },
              {
                key: 'production_to_battery',
                percentage: 'production_to_battery_rate',
                label:
                  'widgets.siteStatsOverviewProduction.production_to_battery',
              },
              {
                key: 'to_grid',
                percentage: 'export_total_to_grid_rate',
                label: 'widgets.siteStatsOverviewProduction.to_grid',
              },
            ],
            graphColors: ['to_shared', 'production_to_battery', 'to_grid'],
            title: 'widgets.siteStatsOverviewProduction.title',
            devID: 'playful-flamingo',
            devPath:
              'site-energy->org:admin->prosumage->siteStatsOverviewProduction',
          },
          {
            order: 3,
            className: 'grid-xs-12 grid-lg-4 pb-0_5',
            env: 'web',
            type: 'map',
            gradientBorder: false,
            id: 'map',
            context: 'site-energy',
            devID: 'quirksome-iceberg',
            devPath: 'site-energy->org:admin->prosumage->map',
          },
          {
            id: 'selfSufficiencyCard',
            keep: false,
          },
          {
            order: 5,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 px-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,
            subtype: 'sharedEnergyCard',
            id: 'sharedEnergyCard',
            totalValue: 'total_shared',
            icon: 'shared_energy',
            descriptionType: 'web:label+value|label+value',
            description: [
              {
                key: 'widgets.sharedEnergyCard.description.rate_consumption',
                value: ['from_shared', 'from_grid_from_shared_rate'],
              },
              {
                key: 'widgets.sharedEnergyCard.description.rate_production',
                value: ['to_shared', 'to_grid_to_shared_rate'],
              },
            ],
            devID: 'bizarre-carnet',
            devPath: 'site-energy->org:admin->prosumage->sharedEnergyCard',
          },
          {
            order: 6,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            env: 'web',
            type: 'card',
            gradientBorder: false,
            detail: false,

            kpiContext: 'ancillary',
            subtype: 'pollutionCard',
            id: 'pollutionCard',
            totalValue: 'co2_offset_kgs',
            trees: 'co2_offset_trees',
            icon: 'pollution',
            descriptionValue: 'co2_offset_trees',
            descriptionType: '{{trees}}',
            description: {
              line_1: 'widgets.pollutionCard.description.prosumage.line_1',
              line_2: 'widgets.pollutionCard.description.prosumage.line_2',
            },
            devID: 'bizarre-saxophone',
            devPath: 'site-energy->org:admin->prosumage->pollutionCard',
          },

          {
            order: 7,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            env: 'web',
            type: 'graphs',
            gradientBorder: false,
            subtype: 'consumptionStackBar',
            id: 'consumptionStackBar',
            totalValue: 'import_total',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'self_consumption_battery',
                color: 'self_consumption_battery',
                combined: false,
              },
              {
                key: 'from_shared',
                color: 'from_shared',
                combined: false,
                base: false,
              },
              {
                key: 'from_grid',
                color: 'from_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'self_consumption_battery',
                colorShade: '',
              },
              {
                color: 'from_shared',
                colorShade: '',
              },
              {
                color: 'from_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.consumptionStackBar.title',
            devID: 'cannibal-tangerine',
            devPath: 'site-energy->org:admin->prosumage->consumptionStackBar',
          },
          {
            order: 8,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            type: 'graphs',
            gradientBorder: false,
            env: 'web',
            subtype: 'productionStackBar',
            id: 'productionStackBar',
            totalValue: 'export_total',
            graphKeys: [
              {
                key: 'self_consumption_direct',
                color: 'self_consumption',
                combined: false,
              },
              {
                key: 'production_to_battery',
                color: 'production_to_battery',
                combined: false,
              },
              {
                key: 'to_shared',
                color: 'to_shared',
                combined: false,
                base: false,
              },
              {
                key: 'to_grid',
                color: 'to_grid',
                combined: false,
                base: false,
              },
            ],

            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'production_to_battery',
                colorShade: '',
              },
              {
                color: 'to_shared',
                colorShade: '',
              },
              {
                color: 'to_grid',
                colorShade: '',
              },
            ],
            title: 'widgets.productionStackBar.title',
            devID: 'glowing-jigsaw',
            devPath: 'site-energy->org:admin->prosumage->productionStackBar',
          },
          {
            order: 9,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pr-lg-0_5',
            id: 'batteryChart',
            title: 'widgets.batteryChart.title',
            type: 'batteryChart',
            gradientBorder: false,
            context: 'site',
            buttons: [
              'widgets.batteryChart.self_consumption',
              'widgets.batteryChart.soc',
            ],
            colors: [
              {
                color: 'self_consumption',
                colorShade: '',
              },
              {
                color: 'battery_soc',
                colorShade: '',
              },
            ],
            db_fields: ['battery_net_flow', 'soc_battery'],
            devID: 'angry-waffle',
            devPath: 'site-energy->org:admin->prosumage->batteryChart',
          },
          {
            order: 10,
            className: 'grid-xs-12 grid-lg-6 p-1 py-xs-0_5 pl-lg-0_5',
            id: 'areaChartSelfConsumptionSite',
            title: 'widgets.areaChartSelfConsumptionCommunity.title',
            type: 'areaChart',
            subtype: 'areaChart',
            gradientBorder: false,
            view: 'site',
            graphKeys: ['import_total', 'export_total', 'total_shared'],
            colors: ['import', 'export', 'total_shared'],
            devID: 'angry-saxophone',
            devPath:
              'site-energy->org:admin->prosumage->areaChartSelfConsumptionSite',
          },
        ],
      },
    },
  },

  // SITE ECONOMICS
  {
    name: 'site-economics',
    active: {
      default: true,
    },
    visible: {
      default: false,
    },
    footer: {
      default: false,
    },
    header: {
      default: false,
    },
    datePicker: {
      default: false,
    },
    pullToRefresh: {
      default: false,
    },
    needsAuth: true,
    needsID: true,
    apis: {
      default: [
        'AppConfigResolver',
        'EntitiesResolver',
        'SiteOverviewResolver',
        'EconomicsKpiSiteResolver',
        'EconomicsCustomKpiSiteResolver',
      ],
    },
    widgets: {
      default: [
        {
          className: 'grid-12 mb-10_5 mb-lg-6_5',
          order: 0,
          type: 'headerWeb',
          id: 'headerWeb',
          data: {
            label: 'site-economics',
            breadCrumbs: true,
            navigation: true,
            calendar: true,
            download: false,
            searchBar: true,
            profile: true,
          },
          devID: 'fantastic-shark',
          devPath: 'site-economics->default->headerWeb',
        },
        {
          order: 1,
          className: 'grid-xs-12 ',
          id: 'rowsWrapper',
          type: 'rowsWrapper',
          devID: 'trendy-wrapper',
          devPath: 'site-economics->default->rowsWrapper',
          items: [
            {
              className: 'grid-12 grid-lg-6 p-1 pb-xs-0_5 pt-xs-0 pr-lg-0_5',
              order: 1,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'siteCostsCard',
              id: 'siteCostsCard',
              totalValue: 'total_costs',
              icon: 'bill_no currency_solid',
              descriptionType: 'dynamic-label',
              descriptionNoData:
                'widgets.siteCostsCard.description.default_no_data',
              additionalFields: [
                {
                  field: 'community_costs',
                  label: 'widgets.siteCostsCard.community_costs',
                },
                {
                  field: 'other_costs',
                  label: 'widgets.siteCostsCard.other_costs',
                },
              ],
              description: 'widgets.siteCostsCard.description.default',
              descriptionCallback: 'siteTotalCosts',
              kpiContext: 'economics',
              devID: 'banished-kangaroo',
              devPath: 'site-economics->default->siteCostsCard',
              drawerConfig: {
                titleKey: 'drawers.siteCostsCard.title',
                descriptionKey: 'drawers.siteCostsCard.description.default',
                listTitleKey: 'drawers.siteCostsCard.list_title',
                listTitleCostsKey: 'drawers.siteCostsCard.list_title_costs',
              },
            },
            {
              className: 'grid-12 grid-lg-6 p-1 py-xs-0_5 pt-lg-0 px-lg-0_5',
              order: 2,
              env: 'web',
              type: 'card',
              gradientBorder: false,
              subtype: 'siteBenefitsCard',
              id: 'siteBenefitsCard',
              totalValue: 'total_benefits',
              icon: 'savings',
              descriptionType: 'dynamic-label',
              additionalFields: [
                {
                  field: 'revenues',
                  label: 'widgets.siteBenefitsCard.revenues',
                },
                {
                  field: 'savings',
                  label: 'widgets.siteBenefitsCard.savings',
                },
              ],
              description: 'widgets.siteBenefitsCard.description.default',
              descriptionNoData:
                'widgets.siteBenefitsCard.description.default_no_data',
              descriptionCallback: 'SiteTotalEstimatedBenefits',
              devID: 'boring-banana',
              devPath: 'site-economics->default->siteBenefitsCard',
              drawerConfig: {
                titleKey:
                  'drawers.SiteTotalEstimatedBenefitsDrawerContent.title',
                descriptionKey:
                  'drawers.SiteTotalEstimatedBenefitsDrawerContent.description',
                listTitleKey:
                  'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title',
                listTitleCostsKey:
                  'drawers.SiteTotalEstimatedBenefitsDrawerContent.list_title_costs',
              },
            },
          ],
        },

        {
          className: 'grid-12 grid-lg-6 p-1 py-xs-0_5 pt-xs-0 pr-lg-0_5',
          order: 4,
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'costsStackBar',
          id: 'costsStackBar',
          totalValue: 'total_costs',
          graphKeys: [
            {
              key: 'community_costs',
              color: 'cost_1',
              combined: false,
            },
            {
              key: 'other_costs',
              color: 'cost_2',
              combined: false,
            },
          ],
          colors: ['cost_1', 'cost_2'],
          title: 'widgets.costsStackBar.title',
          devID: 'nocturnal-nightingale',
          hideWhen: 'HIDE_ON_KWICK_DAYS',
          devPath: 'site-economics->default->costsStackBar',
        },

        {
          className: 'grid-12 grid-lg-6 p-1 py-xs-0_5 pt-xs-0 pl-lg-0_5',
          order: 5,
          env: 'web',
          type: 'graphs',
          gradientBorder: false,
          subtype: 'benefitsStackBar',
          id: 'benefitsStackBar',
          totalValue: 'total_benefits',
          graphKeys: [
            {
              key: 'revenues',
              color: 'revenues',
              combined: false,
            },
            {
              key: 'savings',
              color: 'savings',
              combined: false,
            },
          ],
          colors: ['revenues', 'savings'],
          title: 'widgets.benefitsStackBar.title',
          devID: 'angry-crocodile',
          hideWhen: 'HIDE_ON_KWICK_DAYS',
          devPath: 'site-economics->default->benefitsStackBar',
        },
      ],
    },
  },
];

const finalMergedConfig = mergeConfigDesktop(KWICK_MODULES);

const communityModule = finalMergedConfig.find(
  (module: any) => module?.name === 'community'
);
const communitiesModule = finalMergedConfig.find(
  (module: any) => module?.name === 'communities'
);

if (communityModule && communitiesModule) {
  communitiesModule.widgets = {
    ...(communitiesModule.widgets || {}),
    'org:end_user': communityModule.widgets?.['org:end_user'],
  };
}

// End users reuse the staff layout on any module that does NOT declare its own
// `org:end_user` branch above (the entity pages — community, community-energy,
// site, member — declare theirs inline). org:admin <-> org:supervisor are already
// mirrored by mergeConfigDesktop.
finalMergedConfig.forEach((module: any) => {
  const w = module?.widgets;
  if (w && typeof w === 'object' && !w['org:end_user']) {
    const staff = w['org:supervisor'] || w['org:admin'];
    if (staff) w['org:end_user'] = staff;
  }
});

const replaceEndUserHeaderWeb = (node: any): any => {
  if (Array.isArray(node)) {
    const items = node.map(replaceEndUserHeaderWeb);
    const hasEndUserHeader = items.some(
      (item: any) =>
        item &&
        typeof item === 'object' &&
        (item.id === 'headerWebEndUser' || item.type === 'headerWebEndUser')
    );
    const removesBaseHeader = items.some(
      (item: any) =>
        item &&
        typeof item === 'object' &&
        item.id === 'headerWeb' &&
        item.keep === false
    );

    return hasEndUserHeader && !removesBaseHeader
      ? [{ id: 'headerWeb', keep: false }, ...items]
      : items;
  }

  if (!node || typeof node !== 'object') {
    return node;
  }

  const next = { ...node };

  if (next.id === 'headerWeb' || next.type === 'headerWeb') {
    next.id = 'headerWebEndUser';
    next.type = 'headerWebEndUser';
    next.data = {
      ...(next.data || {}),
      searchBar: false,
      download: false,
    };
  }

  Object.keys(next).forEach((key) => {
    if (next[key] && typeof next[key] === 'object') {
      next[key] = replaceEndUserHeaderWeb(next[key]);
    }
  });

  return next;
};

finalMergedConfig.forEach((module: any) => {
  const endUserWidgets = module?.widgets?.['org:end_user'];
  if (endUserWidgets) {
    module.widgets['org:end_user'] = replaceEndUserHeaderWeb(endUserWidgets);
  }
});

// FLEXO-6076 #5: multi-site member/community aggregates resolve their layout via
// getSiteTypes(), which returns `consumer_producer` and `prosumer_battery` — keys the
// site module never defined (it only had the single-site raw types consumer/producer/
// prosumer/prosumage), so those aggregates fell back to the admin `default` layout.
// Reuse the existing end-user layouts by reference (no duplication): a consumer+producer
// mix maps to the prosumer layout, a battery mix maps to the prosumage layout.
const _siteEndUserWidgets = finalMergedConfig.find(
  (m: any) => m?.name === 'site'
)?.widgets?.['org:end_user'];
if (_siteEndUserWidgets) {
  if (_siteEndUserWidgets.prosumer && !_siteEndUserWidgets.consumer_producer) {
    _siteEndUserWidgets.consumer_producer = _siteEndUserWidgets.prosumer;
  }
  if (_siteEndUserWidgets.prosumage && !_siteEndUserWidgets.prosumer_battery) {
    _siteEndUserWidgets.prosumer_battery = _siteEndUserWidgets.prosumage;
  }
}

export default finalMergedConfig;

// Force full page reload when module config changes (HMR can't hot-swap routes)
if ((import.meta as unknown as { hot?: { decline: () => void } }).hot) {
  (import.meta as unknown as { hot: { decline: () => void } }).hot.decline();
}
